var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelecommunications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 307,
    viewBox: "0 0 346 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1692_12071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 235.216V89.7563L26.1063 75.9989L45.691 86.3168L45.6917 122.008L55.4841 116.849V103.091L65.2764 97.9319V45.5738L94.6543 30.0959L107.711 36.975V53.0453L120.768 46.1662L133.825 53.0453V82.8562L146.882 89.717V61.1317L159.939 54.2526L176.261 62.8515V97.2461L192.582 88.6473V38.8049L212.166 28.4863L235.016 40.5247V79.9832L244.809 85.1425V103.222L257.866 110.101V48.2594L274.187 39.6613L293.772 49.9792V64.666L303.564 69.8253V109.503L316.621 116.382V89.5345L336.207 79.2159L345.999 84.3752L346 235.216H0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 154.474L115.46 153.014V150.807L118.232 152.267V154.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 162.613L115.46 161.152V158.946L118.232 160.406V162.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 150.405L115.46 148.944V146.738L118.232 148.199V150.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 146.054L115.46 144.593V142.386L118.232 143.847V146.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 158.543L115.46 157.083V154.876L118.232 156.337V158.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 129.777L115.46 128.316V126.109L118.232 127.57V129.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 125.708L115.46 124.247V122.04L118.232 123.501V125.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 133.846L115.46 132.385V130.178L118.232 131.639V133.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 141.985L115.46 140.524V138.317L118.232 139.778V141.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 137.915L115.46 136.454V134.248L118.232 135.708V137.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 174.82L115.46 173.36V171.153L118.232 172.613V174.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 195.449L115.46 193.988V191.781L118.232 193.242V195.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 187.028L115.46 185.567V183.361L118.232 184.821V187.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 191.38L115.46 189.919V187.712L118.232 189.173V191.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 203.587L115.46 202.127V199.92L118.232 201.38V203.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 199.518L115.46 198.058V195.851L118.232 197.311V199.518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 170.751L115.46 169.29V167.084L118.232 168.544V170.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 182.958L115.46 181.498V179.292L118.232 180.752V182.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 166.682L115.46 165.221V163.015L118.232 164.475V166.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 121.639L115.46 120.178V117.971L118.232 119.432V121.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 178.889L115.46 177.429V175.222L118.232 176.682V178.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 71.362L115.46 69.9013V67.6943L118.232 69.1551V71.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 67.2927L115.46 65.8319V63.625L118.232 65.0857V67.2927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 63.2236L115.46 61.7628V59.5559L118.232 61.0167V63.2236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 204.624L109.712 203.163V200.957L112.484 202.417V204.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 200.554L109.712 199.094V196.887L112.484 198.348V200.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 208.693L109.712 207.232V205.026L112.484 206.486V208.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 212.762L109.712 211.302V209.095L112.484 210.555V212.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 207.656L115.46 206.196V203.989L118.232 205.45V207.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 83.5695L115.46 82.1088V79.9019L118.232 81.3626V83.5695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 104.78L115.46 103.319V101.113L118.232 102.573V104.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 100.428L115.46 98.9672V96.761L118.232 98.221V100.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 109.431L115.46 107.97V105.763L118.232 107.224V109.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 95.777L115.46 94.3163V92.1094L118.232 93.5701V95.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 113.5L115.46 112.039V109.833L118.232 111.293V113.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 117.57L115.46 116.109V113.902L118.232 115.363V117.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 75.4311L115.46 73.9703V71.7634L118.232 73.2242V75.4311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 79.5002L115.46 78.0394V75.8325L118.232 77.2933V79.5002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 91.7077L115.46 90.247V88.04L118.232 89.5008V91.7077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 87.6386L115.46 86.1779V83.9709L118.232 85.4317V87.6386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 74.0937L67.1777 72.633V70.4268L69.9501 71.8868V74.0937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 148.289L67.1777 146.829V144.622L69.9501 146.082V148.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 144.22L67.1777 142.759V140.553L69.9501 142.013V144.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 140.151L67.1777 138.69V136.483L69.9501 137.944V140.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 152.359L67.1777 150.898V148.691L69.9501 150.152V152.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 156.428L67.1777 154.967V152.761L69.9501 154.221V156.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 115.154L67.1777 113.693V111.487L69.9501 112.947V115.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 123.874L67.1777 122.413V120.207L69.9501 121.667V123.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 136.082L67.1777 134.621V132.414L69.9501 133.875V136.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 119.805L67.1777 118.344V116.138L69.9501 117.598V119.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 127.944L67.1777 126.483V124.277L69.9501 125.737V127.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 160.779L67.1777 159.319V157.112L69.9501 158.573V160.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 132.013L67.1777 130.552V128.346L69.9501 129.806V132.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 193.333L67.1777 191.872V189.666L69.9501 191.126V193.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 189.264L67.1777 187.803V185.596L69.9501 187.057V189.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 201.754L67.1777 200.293V198.087L69.9501 199.547V201.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 185.195L67.1777 183.734V181.527L69.9501 182.988V185.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 197.403L67.1777 195.942V193.735L69.9501 195.196V197.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 172.987L67.1777 171.527V169.32L69.9501 170.781V172.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 181.125L67.1777 179.665V177.458L69.9501 178.919V181.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 168.917L67.1777 167.457V165.25L69.9501 166.711V168.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 164.848L67.1777 163.388V161.181L69.9501 162.642V164.848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 177.056L67.1777 175.596V173.389L69.9501 174.85V177.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 78.1631L67.1777 76.703V74.4961L69.9501 75.9561V78.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 53.7478L67.1777 52.287V50.0808L69.9501 51.5409V53.7478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 111.085L67.1777 109.624V107.417L69.9501 108.878V111.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 57.8174L67.1777 56.3566V54.1504L69.9501 55.6104V57.8174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 65.9555L67.1777 64.4948V62.2886L69.9501 63.7493V65.9555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 61.8864L67.1777 60.4257V58.2195L69.9501 59.6795V61.8864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 98.7988L67.1777 97.338V95.1311L69.9501 96.5919V98.7988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 94.7297L67.1777 93.2689V91.062L69.9501 92.5228V94.7297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 106.936L67.1777 105.476V103.27L69.9501 104.73V106.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 102.868L67.1777 101.407V99.2004L69.9501 100.661V102.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 70.0246L67.1777 68.5639V66.3577L69.9501 67.8177V70.0246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 90.3706L67.1777 88.9098V86.7036L69.9501 88.1637V90.3706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.232 211.726L115.46 210.265V208.058L118.232 209.519V211.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 196.485L109.712 195.025V192.818L112.484 194.279V196.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 82.2324L67.1777 80.7716V78.5654L69.9501 80.0255V82.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 86.3015L67.1777 84.8407V82.6345L69.9501 84.0946V86.3015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 61.6835L211.269 60.2228V58.0159L214.041 59.4766V61.6835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 118.978L211.269 117.517V115.31L214.041 116.771V118.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 127.116L211.269 125.655V123.448L214.041 124.909V127.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 139.323L211.269 137.863V135.656L214.041 137.117V139.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 131.185L211.269 129.724V127.518L214.041 128.978V131.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 135.254L211.269 133.794V131.587L214.041 133.047V135.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 123.047L211.269 121.586V119.379L214.041 120.84V123.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 94.2368L211.269 92.776V90.5691L214.041 92.0298V94.2368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 98.3061L211.269 96.8453V94.6384L214.041 96.0992V98.3061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 102.375L211.269 100.914V98.7075L214.041 100.168V102.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 106.77L211.269 105.309V103.103L214.041 104.563V106.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 110.839L211.269 109.379V107.172L214.041 108.632V110.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 114.908L211.269 113.448V111.241L214.041 112.701V114.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 168.09L211.269 166.629V164.423L214.041 165.883V168.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 172.159L211.269 170.698V168.492L214.041 169.952V172.159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 176.228L211.269 174.768V172.562L214.041 174.022V176.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 180.298L211.269 178.837V176.631L214.041 178.091V180.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 164.021L211.269 162.56V160.354L214.041 161.814V164.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 155.883L211.269 154.422V152.216L214.041 153.676V155.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 151.813L211.269 150.353V148.146L214.041 149.607V151.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 159.952L211.269 158.491V156.285L214.041 157.745V159.952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 147.744L211.269 146.283V144.077L214.041 145.537V147.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 143.393L211.269 141.932V139.725L214.041 141.186V143.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 184.367L211.269 182.906V180.7L214.041 182.16V184.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 210.101L205.521 208.641V206.434L208.294 207.895V210.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 90.1677L211.269 88.7069V86.5L214.041 87.9608V90.1677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 206.032L205.521 204.571V202.365L208.294 203.826V206.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 193.824L205.521 192.364V190.157L208.294 191.618V193.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 197.893L205.521 196.432V194.226L208.294 195.687V197.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 201.962L205.521 200.502V198.295L208.294 199.756V201.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 77.9602L211.269 76.4994V74.2925L214.041 75.7532V77.9602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 73.8908L211.269 72.4301V70.2231L214.041 71.6839V73.8908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 86.0986L211.269 84.6378V82.4309L214.041 83.8917V86.0986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 82.0295L211.269 80.5687V78.3618L214.041 79.8226V82.0295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 69.8217L211.269 68.361V66.1541L214.041 67.6148V69.8217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 57.6144L211.269 56.1537V53.9468L214.041 55.4075V57.6144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 65.7526L211.269 64.2919V62.085L214.041 63.5457V65.7526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 53.5451L211.269 52.0844V49.8774L214.041 51.3382V53.5451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 205.823L67.1777 204.362V202.155L69.9501 203.616V205.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 126.744L109.712 125.284V123.077L112.484 124.538V126.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 130.813L109.712 129.353V127.146L112.484 128.607V130.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 188.718L211.269 187.258V185.051L214.041 186.512V188.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 138.951L109.712 137.491V135.284L112.484 136.745V138.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 143.021L109.712 141.561V139.354L112.484 140.815V143.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 147.373L109.712 145.912V143.706L112.484 145.166V147.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 114.537L109.712 113.076V110.869L112.484 112.33V114.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 110.468L109.712 109.007V106.8L112.484 108.261V110.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 106.398L109.712 104.938V102.731L112.484 104.192V106.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 118.606L109.712 117.146V114.939L112.484 116.399V118.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 122.675L109.712 121.215V119.008L112.484 120.469V122.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 179.926L109.712 178.465V176.259L112.484 177.719V179.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 151.442L109.712 149.981V147.775L112.484 149.235V151.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 183.995L109.712 182.535V180.328L112.484 181.788V183.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 171.788L109.712 170.327V168.121L112.484 169.581V171.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 188.347L109.712 186.887V184.68L112.484 186.14V188.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 175.857L109.712 174.396V172.19L112.484 173.65V175.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 155.511L109.712 154.05V151.844L112.484 153.304V155.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 167.719L109.712 166.258V164.052L112.484 165.512V167.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 159.58L109.712 158.12V155.913L112.484 157.373V159.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 163.649L109.712 162.189V159.982L112.484 161.442V163.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 134.882L109.712 133.422V131.215L112.484 132.676V134.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 213.134L211.269 211.673V209.466L214.041 210.927V213.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 209.065L211.269 207.604V205.397L214.041 206.858V209.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 192.416L109.712 190.956V188.749L112.484 190.21V192.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 101.747L109.712 100.286V98.0801L112.484 99.5408V101.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 196.857L211.269 195.396V193.189L214.041 194.65V196.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 200.926L211.269 199.466V197.259L214.041 198.72V200.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 204.996L211.269 203.535V201.328L214.041 202.789V204.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.041 192.787L211.269 191.327V189.12L214.041 190.581V192.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 84.6061L109.712 83.1454V80.9385L112.484 82.3992V84.6061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 88.6745L109.712 87.2145V85.0076L112.484 86.4683V88.6745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 92.7446L109.712 91.2838V89.0769L112.484 90.5377V92.7446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 97.3957L109.712 95.9349V93.728L112.484 95.1888V97.3957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 80.5363L109.712 79.0763V76.8694L112.484 78.3301V80.5363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 64.2602L109.712 62.7994V60.5925L112.484 62.0533V64.2602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 68.3293L109.712 66.8685V64.6616L112.484 66.1224V68.3293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 60.1911L109.712 58.7304V56.5234L112.484 57.9842V60.1911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 76.468L109.712 75.0072V72.8003L112.484 74.261V76.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.484 72.3982L109.712 70.9381V68.7312L112.484 70.192V72.3982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 205.165L14.0381 203.705V201.498L16.8104 202.959V205.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 209.892L67.1777 208.432V206.225L69.9501 207.685V209.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 185.573L8.28906 184.113V181.906L11.0614 183.367V185.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 193.994L8.28906 192.533V190.327L11.0614 191.788V193.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 181.504L8.28906 180.043V177.836L11.0614 179.297V181.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 198.063L8.28906 196.602V194.396L11.0614 195.856V198.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 173.366L8.28906 171.905V169.698L11.0614 171.159V173.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 161.158L8.28906 159.698V157.491L11.0614 158.951V161.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 165.227L8.28906 163.767V161.56L11.0614 163.021V165.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 169.297L8.28906 167.836V165.629L11.0614 167.09V169.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 202.132L8.28906 200.671V198.465L11.0614 199.926V202.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 210.271L8.28906 208.81V206.604L11.0614 208.065V210.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 214.34L8.28906 212.879V210.673L11.0614 212.134V214.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 206.201L8.28906 204.741V202.534L11.0614 203.994V206.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 157.089L8.28906 155.628V153.421L11.0614 154.882V157.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 177.435L8.28906 175.974V173.767L11.0614 175.228V177.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 153.02L8.28906 151.559V149.352L11.0614 150.813V153.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 103.767L8.28906 102.307V100.1L11.0614 101.561V103.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 107.836L8.28906 106.376V104.169L11.0614 105.63V107.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 99.6819L8.28906 98.2211V96.0149L11.0614 97.4749V99.6819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 136.46L8.28906 135V132.793L11.0614 134.254V136.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 112.045L8.28906 110.585V108.378L11.0614 109.839V112.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 140.53L8.28906 139.069V136.863L11.0614 138.323V140.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 148.668L8.28906 147.208V145.001L11.0614 146.462V148.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 144.599L8.28906 143.139V140.932L11.0614 142.392V144.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 132.391L8.28906 130.931V128.724L11.0614 130.184V132.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 116.114L8.28906 114.654V112.448L11.0614 113.908V116.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 120.184L8.28906 118.724V116.517L11.0614 117.977V120.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 124.253L8.28906 122.793V120.586L11.0614 122.047V124.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 128.322L8.28906 126.862V124.655L11.0614 126.116V128.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 180.467L14.0381 179.007V176.801L16.8104 178.261V180.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 201.096L14.0381 199.636V197.429L16.8104 198.889V201.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 189.755L205.521 188.294V186.088L208.294 187.549V189.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 213.303L14.0381 211.843V209.636L16.8104 211.097V213.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 192.675L14.0381 191.214V189.008L16.8104 190.468V192.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 188.606L14.0381 187.145V184.938L16.8104 186.399V188.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 197.026L14.0381 195.566V193.359L16.8104 194.82V197.026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 184.537L14.0381 183.076V180.869L16.8104 182.33V184.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 209.235L14.0381 207.774V205.567L16.8104 207.028V209.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 176.398L14.0381 174.938V172.731L16.8104 174.191V176.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 115.078L14.0381 113.618V111.411L16.8104 112.871V115.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 110.869L14.0381 109.409V107.202L16.8104 108.662V110.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 123.217L14.0381 121.756V119.549L16.8104 121.01V123.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 127.286L14.0381 125.825V123.618L16.8104 125.079V127.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 102.714L14.0381 101.254V99.0474L16.8104 100.507V102.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 131.355L14.0381 129.894V127.688L16.8104 129.148V131.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 106.8L14.0381 105.339V103.133L16.8104 104.593V106.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 119.147L14.0381 117.687V115.48L16.8104 116.94V119.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 160.122L14.0381 158.661V156.454L16.8104 157.915V160.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 164.191L14.0381 162.73V160.524L16.8104 161.984V164.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 168.26L14.0381 166.799V164.593L16.8104 166.053V168.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 156.052L14.0381 154.592V152.385L16.8104 153.846V156.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 172.329L14.0381 170.868V168.662L16.8104 170.122V172.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 151.701L14.0381 150.24V148.033L16.8104 149.494V151.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 139.493L14.0381 138.033V135.826L16.8104 137.286V139.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 143.562L14.0381 142.102V139.895L16.8104 141.356V143.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 147.631L14.0381 146.171V143.964L16.8104 145.425V147.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 135.424L14.0381 133.964V131.757L16.8104 133.217V135.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 189.643L8.28906 188.182V185.975L11.0614 187.436V189.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 147.253L72.9268 145.792V143.586L75.6991 145.046V147.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 143.184L72.9268 141.723V139.517L75.6991 140.977V143.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 151.322L72.9268 149.861V147.655L75.6991 149.115V151.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 155.391L72.9268 153.93V151.724L75.6991 153.185V155.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 114.117L72.9268 112.657V110.45L75.6991 111.91V114.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 135.045L72.9268 133.584V131.378L75.6991 132.839V135.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 122.838L72.9268 121.378V119.171L75.6991 120.631V122.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 159.46L72.9268 158V155.793L75.6991 157.253V159.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 118.186L72.9268 116.726V114.52L75.6991 115.98V118.186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 126.907L72.9268 125.446V123.24L75.6991 124.701V126.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 130.976L72.9268 129.515V127.309L75.6991 128.77V130.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 139.114L72.9268 137.653V135.447L75.6991 136.908V139.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 188.227L72.9268 186.767V184.56L75.6991 186.021V188.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 184.158L72.9268 182.698V180.491L75.6991 181.951V184.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 192.297L72.9268 190.836V188.629L75.6991 190.09V192.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 200.435L72.9268 198.974V196.767L75.6991 198.228V200.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 196.366L72.9268 194.905V192.698L75.6991 194.159V196.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 167.882L72.9268 166.421V164.214L75.6991 165.675V167.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 163.812L72.9268 162.352V160.145L75.6991 161.606V163.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 171.951L72.9268 170.49V168.283L75.6991 169.744V171.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 180.089L72.9268 178.628V176.421L75.6991 177.882V180.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 176.02L72.9268 174.559V172.352L75.6991 173.813V176.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 60.8496L72.9268 59.3895V57.1826L75.6991 58.6434V60.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 204.786L72.9268 203.325V201.119L75.6991 202.58V204.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9501 213.961L67.1777 212.501V210.294L69.9501 211.754V213.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 64.9187L72.9268 63.4586V61.2517L75.6991 62.7125V64.9187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 109.97L72.9268 108.509V106.302L75.6991 107.763V109.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 97.7619L72.9268 96.3012V94.0942L75.6991 95.555V97.7619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 93.4028L72.9268 91.9428V89.7358L75.6991 91.1966V93.4028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 101.831L72.9268 100.37V98.1636L75.6991 99.6243V101.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 89.3337L72.9268 87.8737V85.6667L75.6991 87.1275V89.3337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 105.901L72.9268 104.44V102.233L75.6991 103.694V105.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 73.0571L72.9268 71.5971V69.3901L75.6991 70.8509V73.0571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 68.9878L72.9268 67.5277V65.3208L75.6991 66.7815V68.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 77.1264L72.9268 75.6664V73.4595L75.6991 74.9202V77.1264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 81.1955L72.9268 79.7355V77.5286L75.6991 78.9893V81.1955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 85.2646L72.9268 83.8046V81.5977L75.6991 83.0584V85.2646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 56.7805L72.9268 55.3204V53.1135L75.6991 54.5743V56.7805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 162.194L2.54199 160.734V158.527L5.31431 159.988V162.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 137.497L2.54199 136.036V133.83L5.31431 135.29V137.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 170.333L2.54199 168.873V166.666L5.31431 168.127V170.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 174.403L2.54199 172.942V170.735L5.31431 172.196V174.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 178.472L2.54199 177.011V174.804L5.31431 176.265V178.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 158.125L2.54199 156.665V154.458L5.31431 155.919V158.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 141.566L2.54199 140.105V137.899L5.31431 139.359V141.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 154.056L2.54199 152.596V150.389L5.31431 151.85V154.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 145.635L2.54199 144.175V141.969L5.31431 143.429V145.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 149.987L2.54199 148.527V146.32L5.31431 147.781V149.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 166.264L2.54199 164.803V162.596L5.31431 164.057V166.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 207.238L2.54199 205.777V203.571L5.31431 205.031V207.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 182.541L2.54199 181.08V178.873L5.31431 180.334V182.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 203.169L2.54199 201.708V199.502L5.31431 200.962V203.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 211.307L2.54199 209.847V207.64L5.31431 209.1V211.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 186.61L2.54199 185.149V182.942L5.31431 184.403V186.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 190.961L2.54199 189.501V187.294L5.31431 188.754V190.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 208.855L72.9268 207.395V205.188L75.6991 206.649V208.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 199.1L2.54199 197.639V195.433L5.31431 196.893V199.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 195.031L2.54199 193.57V191.364L5.31431 192.824V195.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 133.428L2.54199 131.967V129.761L5.31431 131.221V133.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6991 212.925L72.9268 211.464V209.258L75.6991 210.718V212.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 121.22L2.54199 119.759V117.553L5.31431 119.013V121.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 117.151L2.54199 115.69V113.484L5.31431 114.944V117.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 113.082L2.54199 111.621V109.415L5.31431 110.875V113.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 125.29L2.54199 123.829V121.623L5.31431 123.083V125.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 129.359L2.54199 127.898V125.691L5.31431 127.152V129.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 96.6496L2.54199 95.1888V92.9819L5.31431 94.4427V96.6496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 109.013L2.54199 107.552V105.346L5.31431 106.806V109.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 100.735L2.54199 99.2741V97.0679L5.31431 98.5279V100.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31431 104.804L2.54199 103.343V101.137L5.31431 102.597V104.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 190.08L329.059 191.54V189.334L331.83 187.874V190.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 73.1982L260.057 71.7376V69.5312L262.829 70.9914V73.1982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 77.2673L260.057 75.8065V73.5996L262.829 75.0604V77.2673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 69.1289L260.057 67.6681V65.4619L262.829 66.922V69.1289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 81.3366L260.057 79.8759V77.6697L262.829 79.1297V81.3366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 85.4057L260.057 83.945V81.738L262.829 83.1988V85.4057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 89.4748L260.057 88.0141V85.8079L262.829 87.2679V89.4748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 204.644L340.554 206.104V203.898L343.326 202.437V204.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 212.782L340.554 214.242V212.036L343.326 210.575V212.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 208.712L340.554 210.173V207.966L343.326 206.506V208.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 60.9907L260.057 59.5299V57.3237L262.829 58.7838V60.9907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 65.0598L260.057 63.599V61.3921L262.829 62.8528V65.0598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 122.028L260.057 120.568V118.361L262.829 119.821V122.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 93.5441L260.057 92.0834V89.8765L262.829 91.3372V93.5441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 126.098L260.057 124.637V122.431L262.829 123.891V126.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 130.167L260.057 128.706V126.499L262.829 127.96V130.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 113.89L260.057 112.429V110.222L262.829 111.683V113.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 117.959L260.057 116.498V114.292L262.829 115.752V117.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 97.6132L260.057 96.1525V93.9456L262.829 95.4063V97.6132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 101.682L260.057 100.222V98.0146L262.829 99.4754V101.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 109.821L260.057 108.36V106.153L262.829 107.614V109.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 105.752L260.057 104.291V102.084L262.829 103.545V105.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 200.574L340.554 202.035V199.828L343.326 198.368V200.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 143.041L340.554 144.501V142.295L343.326 140.834V143.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 134.903L340.554 136.363V134.157L343.326 132.696V134.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 138.972L340.554 140.432V138.225L343.326 136.765V138.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 134.518L260.057 133.058V130.851L262.829 132.312V134.518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 147.392L340.554 148.853V146.646L343.326 145.186V147.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 126.764L340.554 128.224V126.018L343.326 124.557V126.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 118.626L340.554 120.086V117.88L343.326 116.419V118.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 130.833L340.554 132.293V130.087L343.326 128.626V130.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 122.695L340.554 124.155V121.949L343.326 120.488V122.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 155.531L340.554 156.991V154.784L343.326 153.324V155.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 151.462L340.554 152.922V150.715L343.326 149.255V151.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 179.946L340.554 181.406V179.2L343.326 177.739V179.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 114.557L340.554 116.017V113.811L343.326 112.35V114.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 188.367L340.554 189.827V187.621L343.326 186.16V188.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 192.436L340.554 193.896V191.69L343.326 190.229V192.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 159.6L340.554 161.061V158.854L343.326 157.393V159.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 196.506L340.554 197.966V195.759L343.326 194.299V196.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 163.669L340.554 165.13V162.923L343.326 161.463V163.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 167.738L340.554 169.199V166.992L343.326 165.531V167.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 171.808L340.554 173.268V171.061L343.326 169.601V171.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 175.877L340.554 177.337V175.13L343.326 173.67V175.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 184.015L340.554 185.476V183.269L343.326 181.808V184.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 100.646L265.805 99.185V96.9788L268.577 98.4388V100.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 96.5764L265.805 95.1156V92.9094L268.577 94.3695V96.5764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 104.715L265.805 103.254V101.048L268.577 102.508V104.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 108.784L265.805 107.323V105.117L268.577 106.577V108.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 112.853L265.805 111.392V109.186L268.577 110.646V112.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 76.2304L265.805 74.7697V72.5635L268.577 74.0242V76.2304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 138.587L260.057 137.126V134.92L262.829 136.381V138.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 92.5073L265.805 91.0472V88.8403L268.577 90.3011V92.5073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 116.922L265.805 115.462V113.255L268.577 114.715V116.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 88.4382L265.805 86.9782V84.7712L268.577 86.232V88.4382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 84.3689L265.805 82.9088V80.7019L268.577 82.1627V84.3689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 149.758L265.805 148.298V146.091L268.577 147.552V149.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 141.62L265.805 140.16V137.953L268.577 139.413V141.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 145.689L265.805 144.229V142.022L268.577 143.482V145.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 72.1614L265.805 70.7006V68.4944L268.577 69.9544V72.1614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 153.828L265.805 152.367V150.16L268.577 151.621V153.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 157.897L265.805 156.436V154.229L268.577 155.69V157.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 125.061L265.805 123.6V121.394L268.577 122.854V125.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 120.991L265.805 119.531V117.324L268.577 118.785V120.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 129.13L265.805 127.669V125.463L268.577 126.923V129.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 137.551L265.805 136.09V133.884L268.577 135.344V137.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 133.199L265.805 131.738V129.532L268.577 130.992V133.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 80.2998L265.805 78.839V76.6328L268.577 78.0929V80.2998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 179.562L260.057 178.101V175.894L262.829 177.355V179.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 68.0923L265.805 66.6322V64.4253L268.577 65.886V68.0923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 171.141L260.057 169.681V167.474L262.829 168.934V171.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 158.933L260.057 157.473V155.266L262.829 156.727V158.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 175.493L260.057 174.032V171.825L262.829 173.286V175.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 167.072L260.057 165.611V163.405L262.829 164.865V167.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 146.726L260.057 145.266V143.059L262.829 144.519V146.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 142.656L260.057 141.196V138.99L262.829 140.45V142.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 150.795L260.057 149.335V147.128L262.829 148.588V150.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 154.864L260.057 153.404V151.197L262.829 152.657V154.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 163.002L260.057 161.542V159.335L262.829 160.796V163.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 212.115L260.057 210.655V208.448L262.829 209.908V212.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 208.046L260.057 206.586V204.379L262.829 205.839V208.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 64.0232L265.805 62.5624V60.3562L268.577 61.817V64.0232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 203.977L260.057 202.516V200.309L262.829 201.77V203.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 187.7L260.057 186.24V184.033L262.829 185.493V187.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 183.631L260.057 182.17V179.964L262.829 181.424V183.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 191.769L260.057 190.309V188.102L262.829 189.563V191.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 195.839L260.057 194.378V192.171L262.829 193.632V195.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 199.908L260.057 198.447V196.24L262.829 197.701V199.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 181.942L329.059 183.402V181.195L331.83 179.735V181.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 177.873L329.059 179.333V177.127L331.83 175.666V177.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 173.804L329.059 175.264V173.057L331.83 171.597V173.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 186.011L329.059 187.471V185.265L331.83 183.804V186.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 194.432L329.059 195.893V193.686L331.83 192.225V194.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 153.458L329.059 154.918V152.711L331.83 151.251V153.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 198.501L329.059 199.962V197.755L331.83 196.294V198.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 169.735L329.059 171.195V168.988L331.83 167.528V169.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 157.527L329.059 158.987V156.781L331.83 155.32V157.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 161.596L329.059 163.056V160.849L331.83 159.389V161.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 165.665L329.059 167.125V164.919L331.83 163.458V165.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 185.686L205.521 184.226V182.019L208.294 183.48V185.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 202.57L329.059 204.031V201.824L331.83 200.363V202.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 161.966L265.805 160.505V158.299L268.577 159.759V161.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 206.639L329.059 208.1V205.893L331.83 204.432V206.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 210.709L329.059 212.169V209.962L331.83 208.502V210.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 149.106L329.059 150.567V148.36L331.83 146.899V149.106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 145.037L329.059 146.497V144.29L331.83 142.83V145.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 99.9501L329.059 101.411V99.2039L331.83 97.7432V99.9501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 95.881L329.059 97.3417V95.1348L331.83 93.6741V95.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 128.76L329.059 130.221V128.014L331.83 126.553V128.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 132.829L329.059 134.29V132.083L331.83 130.622V132.829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 124.691L329.059 126.152V123.945L331.83 122.484V124.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 136.898L329.059 138.359V136.152L331.83 134.691V136.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 140.967L329.059 142.428V140.221L331.83 138.76V140.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 116.552L329.059 118.013V115.806L331.83 114.345V116.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 108.088L329.059 109.549V107.342L331.83 105.881V108.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 112.483L329.059 113.944V111.737L331.83 110.276V112.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 104.019L329.059 105.48V103.273L331.83 101.812V104.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83 120.621L329.059 122.082V119.875L331.83 118.415V120.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 154.494L334.806 155.955V153.748L337.578 152.288V154.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 199.538L334.806 200.998V198.792L337.578 197.331V199.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 207.676L334.806 209.136V206.93L337.578 205.469V207.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 211.745L334.806 213.206V210.999L337.578 209.539V211.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 195.469L334.806 196.929V194.722L337.578 193.262V195.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 182.978L334.806 184.439V182.232L337.578 180.772V182.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 187.048L334.806 188.508V186.301L337.578 184.841V187.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 191.4L334.806 192.86V190.653L337.578 189.193V191.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 97.9545L340.554 99.4145V97.2083L343.326 95.7476V97.9545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 93.8854L340.554 95.3454V93.1392L343.326 91.6785V93.8854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 102.024L340.554 103.484V101.277L343.326 99.8167V102.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 106.418L340.554 107.878V105.672L343.326 104.211V106.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 89.8158L340.554 91.2758V89.0696L343.326 87.6089V89.8158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 178.909L334.806 180.37V178.163L337.578 176.703V178.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 203.607L334.806 205.067V202.861L337.578 201.4V203.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 117.589L334.806 119.05V116.843L337.578 115.382V117.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 113.52L334.806 114.981V112.774L337.578 111.313V113.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 121.658L334.806 123.119V120.912L337.578 119.451V121.658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 125.727L334.806 127.188V124.981L337.578 123.521V125.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 109.451L334.806 110.912V108.705L337.578 107.244V109.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 129.797L334.806 131.258V129.051L337.578 127.59V129.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 174.84L334.806 176.3V174.094L337.578 172.633V174.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 105.056L334.806 106.517V104.31L337.578 102.849V105.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 92.8485L334.806 94.3093V92.1023L337.578 90.6416V92.8485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 100.987L334.806 102.447V100.241L337.578 98.7798V100.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 96.9176L334.806 98.3784V96.1714L337.578 94.7107V96.9176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 158.563L334.806 160.024V157.817L337.578 156.357V158.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.326 110.488L340.554 111.948V109.742L343.326 108.281V110.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 162.632L334.806 164.093V161.886L337.578 160.426V162.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 166.702L334.806 168.162V165.955L337.578 164.495V166.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 133.866L334.806 135.326V133.12L337.578 131.659V133.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 170.771L334.806 172.231V170.024L337.578 168.564V170.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 137.935L334.806 139.396V137.189L337.578 135.728V137.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 150.425L334.806 151.885V149.679L337.578 148.219V150.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 142.004L334.806 143.465V141.258L337.578 139.797V142.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 146.073L334.806 147.534V145.327L337.578 143.866V146.073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 121.051L199.773 119.59V117.384L202.546 118.844V121.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 125.12L199.773 123.659V121.453L202.546 122.914V125.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 129.189L199.773 127.728V125.522L202.546 126.983V129.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 137.327L199.773 135.866V133.66L202.546 135.12V137.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 133.258L199.773 131.797V129.591L202.546 131.051V133.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 104.774L199.773 103.314V101.107L202.546 102.567V104.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 141.679L199.773 140.218V138.011L202.546 139.472V141.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 100.705L199.773 99.2441V97.0378L202.546 98.4986V100.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 112.912L199.773 111.452V109.245L202.546 110.705V112.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 108.843L199.773 107.382V105.176L202.546 106.637V108.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 116.981L199.773 115.52V113.314L202.546 114.774V116.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 145.748L199.773 144.288V142.081L202.546 143.542V145.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 174.233L199.773 172.772V170.565L202.546 172.026V174.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 170.164L199.773 168.703V166.496L202.546 167.957V170.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 178.302L199.773 176.841V174.634L202.546 176.095V178.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 96.3098L199.773 94.849V92.6428L202.546 94.1036V96.3098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 166.094L199.773 164.634V162.427L202.546 163.888V166.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 182.653L199.773 181.193V178.986L202.546 180.446V182.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 153.887L199.773 152.426V150.219L202.546 151.68V153.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 149.818L199.773 148.357V146.15L202.546 147.611V149.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 157.956L199.773 156.495V154.288L202.546 155.749V157.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 162.025L199.773 160.564V158.357L202.546 159.818V162.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 204.036L194.024 202.575V200.368L196.797 201.829V204.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 212.174L194.024 210.714V208.507L196.797 209.967V212.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 208.105L194.024 206.644V204.438L196.797 205.898V208.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 47.4797L199.773 46.0197V43.8127L202.546 45.2735V47.4797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 191.828L194.024 190.368V188.161L196.797 189.621V191.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 195.897L194.024 194.437V192.23L196.797 193.69V195.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 92.2407L199.773 90.7799V88.5737L202.546 90.0338V92.2407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 186.722L199.773 185.262V183.055L202.546 184.515V186.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 199.967L194.024 198.506V196.299L196.797 197.76V199.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 51.5488L199.773 50.0888V47.8818L202.546 49.3426V51.5488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 71.8947L199.773 70.4347V68.2278L202.546 69.6878V71.8947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 75.9638L199.773 74.5031V72.2969L202.546 73.7576V75.9638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 88.1714L199.773 86.7106V84.5044L202.546 85.9651V88.1714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 84.1023L199.773 82.6422V80.4353L202.546 81.8954V84.1023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 80.0329L199.773 78.5729V76.366L202.546 77.8267V80.0329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 59.6872L199.773 58.2265V56.0203L202.546 57.481V59.6872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 67.8254L199.773 66.3654V64.1584L202.546 65.6192V67.8254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 55.6179L199.773 54.1571V51.9509L202.546 53.4117V55.6179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 63.7563L199.773 62.2963V60.0894L202.546 61.5494V63.7563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 211.138L199.773 209.677V207.47L202.546 208.931V211.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 190.791L199.773 189.331V187.125L202.546 188.585V190.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 124.083L205.521 122.623V120.416L208.294 121.877V124.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 120.014L205.521 118.554V116.347L208.294 117.807V120.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 166.035L265.805 164.575V162.368L268.577 163.828V166.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 132.221L205.521 130.761V128.554L208.294 130.015V132.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 115.945L205.521 114.485V112.278L208.294 113.738V115.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 103.737L205.521 102.277V100.07L208.294 101.531V103.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 107.806L205.521 106.346V104.139L208.294 105.6V107.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 111.875L205.521 110.415V108.208L208.294 109.669V111.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 140.36L205.521 138.9V136.693L208.294 138.153V140.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 136.29L205.521 134.83V132.624L208.294 134.084V136.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 165.058L205.521 163.597V161.391L208.294 162.851V165.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 173.196L205.521 171.735V169.528L208.294 170.989V173.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 169.127L205.521 167.666V165.459L208.294 166.92V169.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 177.265L205.521 175.804V173.597L208.294 175.058V177.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 181.334L205.521 179.874V177.667L208.294 179.128V181.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 148.781L205.521 147.32V145.113L208.294 146.574V148.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 152.85L205.521 151.389V149.182L208.294 150.643V152.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 144.712L205.521 143.251V141.044L208.294 142.505V144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 160.988L205.521 159.528V157.321L208.294 158.782V160.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 156.919L205.521 155.459V153.252L208.294 154.712V156.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 128.152L205.521 126.692V124.485L208.294 125.945V128.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 187.759L194.024 186.298V184.092L196.797 185.552V187.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 50.5126L205.521 49.0519V46.845L208.294 48.3057V50.5126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 194.861L199.773 193.4V191.194L202.546 192.654V194.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 198.93L199.773 197.469V195.263L202.546 196.723V198.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 202.999L199.773 201.538V199.332L202.546 200.792V202.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.546 207.068L199.773 205.608V203.401L202.546 204.861V207.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 74.927L205.521 73.4669V71.26L208.294 72.7208V74.927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 78.9961L205.521 77.536V75.3291L208.294 76.7898V78.9961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 83.0663L205.521 81.6056V79.3987L208.294 80.8594V83.0663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 95.2736L205.521 93.8129V91.606L208.294 93.0667V95.2736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 91.2038L205.521 89.7438V87.5369L208.294 88.9976V91.2038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 87.1354L205.521 85.6747V83.4678L208.294 84.9285V87.1354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 70.8579L205.521 69.3978V67.1909L208.294 68.6517V70.8579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 58.6511L205.521 57.1903V54.9834L208.294 56.4441V58.6511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 62.7197L205.521 61.2596V59.0527L208.294 60.5135V62.7197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 54.5817L205.521 53.121V50.9141L208.294 52.3748V54.5817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 66.7895L205.521 65.3287V63.1218L208.294 64.5826V66.7895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 99.342L205.521 97.882V95.675L208.294 97.1358V99.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 119.955L271.553 118.495V116.288L274.324 117.748V119.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 124.024L271.553 122.564V120.357L274.324 121.818V124.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 128.093L271.553 126.633V124.426L274.324 125.887V128.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 132.162L271.553 130.702V128.495L274.324 129.956V132.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 136.231L271.553 134.771V132.564L274.324 134.025V136.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 99.6091L271.553 98.1491V95.9421L274.324 97.4029V99.6091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 103.678L271.553 102.218V100.011L274.324 101.472V103.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 140.583L271.553 139.123V136.916L274.324 138.377V140.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 115.885L271.553 114.425V112.219L274.324 113.679V115.885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 107.747L271.553 106.287V104.08L274.324 105.541V107.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 183.69L194.024 182.229V180.022L196.797 181.483V183.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 173.137L271.553 171.676V169.469L274.324 170.93V173.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 144.653L271.553 143.192V140.985L274.324 142.446V144.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 169.068L271.553 167.607V165.4L274.324 166.861V169.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 181.558L271.553 180.097V177.891L274.324 179.351V181.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 177.206L271.553 175.745V173.539L274.324 174.999V177.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 164.998L271.553 163.538V161.331L274.324 162.792V164.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 95.5402L271.553 94.0795V91.8726L274.324 93.3333V95.5402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 152.791L271.553 151.33V149.124L274.324 150.584V152.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 148.722L271.553 147.261V145.054L274.324 146.515V148.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 156.86L271.553 155.4V153.193L274.324 154.653V156.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 160.929L271.553 159.469V157.262L274.324 158.722V160.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 202.94L265.805 201.48V199.273L268.577 200.733V202.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 91.4711L271.553 90.0104V87.8035L274.324 89.2642V91.4711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 194.802L265.805 193.341V191.135L268.577 192.595V194.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 190.733L265.805 189.272V187.066L268.577 188.526V190.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 185.627L271.553 184.167V181.96L274.324 183.42V185.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 198.871L265.805 197.41V195.204L268.577 196.664V198.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 174.173L265.805 172.713V170.506L268.577 171.967V174.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 207.009L265.805 205.549V203.343L268.577 204.803V207.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 170.104L265.805 168.644V166.437L268.577 167.898V170.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 182.594L265.805 181.134V178.927L268.577 180.388V182.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 178.525L265.805 177.064V174.857L268.577 176.318V178.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 186.664L265.805 185.203V182.997L268.577 184.457V186.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 75.1945L271.553 73.7338V71.5269L274.324 72.9876V75.1945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 211.079L265.805 209.618V207.412L268.577 208.872V211.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 79.2632L271.553 77.8031V75.5962L274.324 77.0569V79.2632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 83.3323L271.553 81.8722V79.6653L274.324 81.126V83.3323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 87.4013L271.553 85.9413V83.7344L274.324 85.1951V87.4013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 71.1245L271.553 69.6644V67.4575L274.324 68.9183V71.1245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 67.0554L271.553 65.5953V63.3884L274.324 64.8492V67.0554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 56.9719L260.057 55.5118V53.3049L262.829 54.765V56.9719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.577 60.0046L265.805 58.5446V56.3376L268.577 57.7984V60.0046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 63.0375L271.553 61.5768V59.3699L274.324 60.8306V63.0375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 111.816L271.553 110.356V108.149L274.324 109.61V111.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 126.156L194.024 124.696V122.49L196.797 123.95V126.156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 118.018L194.024 116.557V114.351L196.797 115.811V118.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 122.087L194.024 120.626V118.42L196.797 119.88V122.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 134.295L194.024 132.834V130.627L196.797 132.088V134.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 97.6721L194.024 96.2113V94.0051L196.797 95.4652V97.6721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 130.226L194.024 128.765V126.558L196.797 128.019V130.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 101.741L194.024 100.281V98.0737L196.797 99.5345V101.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 113.949L194.024 112.488V110.281L196.797 111.742V113.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 105.811L194.024 104.35V102.143L196.797 103.604V105.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 109.88L194.024 108.419V106.212L196.797 107.673V109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 189.696L271.553 188.236V186.029L274.324 187.49V189.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 171.199L194.024 169.739V167.532L196.797 168.993V171.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 163.061L194.024 161.601V159.394L196.797 160.855V163.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 167.13L194.024 165.67V163.463L196.797 164.924V167.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 175.269L194.024 173.809V171.602L196.797 173.063V175.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 179.621L194.024 178.16V175.953L196.797 177.414V179.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 146.784L194.024 145.324V143.117L196.797 144.578V146.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 150.853L194.024 149.393V147.187L196.797 148.647V150.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 142.716L194.024 141.255V139.048L196.797 140.509V142.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 158.992L194.024 157.532V155.325L196.797 156.786V158.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 154.923L194.024 153.463V151.256L196.797 152.717V154.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 138.646L194.024 137.186V134.979L196.797 136.44V138.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 93.2773L194.024 91.8166V89.6104L196.797 91.0704V93.2773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 214.111L271.553 212.65V210.444L274.324 211.905V214.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 48.5163L194.024 47.0556V44.8494L196.797 46.3094V48.5163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 44.4472L194.024 42.9865V40.7803L196.797 42.241V44.4472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 193.765L271.553 192.305V190.098L274.324 191.559V193.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 197.834L271.553 196.374V194.167L274.324 195.627V197.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 201.903L271.553 200.443V198.236L274.324 199.697V201.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 205.973L271.553 204.512V202.306L274.324 203.766V205.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.324 210.042L271.553 208.581V206.375L274.324 207.836V210.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 81.0698L194.024 79.6091V77.4028L196.797 78.8629V81.0698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 72.9314L194.024 71.4706V69.2644L196.797 70.7245V72.9314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 77.0005L194.024 75.5397V73.3335L196.797 74.7935V77.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 85.1391L194.024 83.6784V81.4722L196.797 82.9322V85.1391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 89.2082L194.024 87.7475V85.5413L196.797 87.0013V89.2082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 56.6548L194.024 55.194V52.9878L196.797 54.4478V56.6548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 52.5854L194.024 51.1247V48.9185L196.797 50.3785V52.5854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 60.7238L194.024 59.2631V57.0562L196.797 58.5169V60.7238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 64.7932L194.024 63.3324V61.1262L196.797 62.5863V64.7932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.797 68.8623L194.024 67.4015V65.1953L196.797 66.6554V68.8623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 81.0011L93.6523 82.4612V80.2549L96.4239 78.7942V81.0011Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 76.9318L93.6523 78.3925V76.1856L96.4239 74.7249V76.9318Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 85.0702L93.6523 86.5303V84.324L96.4239 82.8633V85.0702Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 89.5592L93.6523 91.0193V88.813L96.4239 87.3523V89.5592Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 93.6283L93.6523 95.0891V92.8821L96.4239 91.4214V93.6283Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 64.5194L93.6523 65.9802V63.7732L96.4239 62.3125V64.5194Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 142.784L93.6523 144.244V142.038L96.4239 140.577V142.784Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 56.3807L93.6523 57.8415V55.6346L96.4239 54.1738V56.3807Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 60.4503L93.6523 61.9111V59.7042L96.4239 58.2434V60.4503Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 97.6974L93.6523 99.1581V96.9512L96.4239 95.4905V97.6974Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 68.5885L93.6523 70.0486V67.8423L96.4239 66.3816V68.5885Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 138.715L93.6523 140.175V137.969L96.4239 136.508V138.715Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 149.886L87.9043 151.346V149.139L90.6766 147.679V149.886Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 122.438L93.6523 123.898V121.692L96.4239 120.231V122.438Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 126.507L93.6523 127.967V125.761L96.4239 124.301V126.507Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 134.646L93.6523 136.106V133.9L96.4239 132.439V134.646Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 101.767L93.6523 103.227V101.021L96.4239 99.5598V101.767Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 52.3117L93.6523 53.7724V51.5655L96.4239 50.1047V52.3117Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 105.836L93.6523 107.297V105.09L96.4239 103.629V105.836Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 109.905L93.6523 111.365V109.159L96.4239 107.698V109.905Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 114.3L93.6523 115.76V113.554L96.4239 112.093V114.3Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 118.369L93.6523 119.829V117.623L96.4239 116.162V118.369Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 72.8212L93.6523 74.282V72.075L96.4239 70.615V72.8212Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 174.583L87.9043 176.044V173.837L90.6766 172.377V174.583Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 178.653L87.9043 180.113V177.907L90.6766 176.446V178.653Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 182.721L87.9043 184.182V181.975L90.6766 180.514V182.721Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 170.514L87.9043 171.975V169.768L90.6766 168.308V170.514Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 186.79L87.9043 188.251V186.044L90.6766 184.584V186.79Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 153.955L87.9043 155.416V153.209L90.6766 151.748V153.955Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 190.86L87.9043 192.321V190.114L90.6766 188.654V190.86Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 158.306L87.9043 159.767V157.56L90.6766 156.1V158.306Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 162.376L87.9043 163.836V161.629L90.6766 160.169V162.376Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 166.444L87.9043 167.905V165.698L90.6766 164.238V166.444Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 203.35L87.9043 204.811V202.604L90.6766 201.143V203.35Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 194.929L87.9043 196.39V194.183L90.6766 192.723V194.929Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 211.488L87.9043 212.949V210.742L90.6766 209.281V211.488Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 48.2426L93.6523 49.7033V47.4964L96.4239 46.0356V48.2426Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 199.281L87.9043 200.741V198.535L90.6766 197.074V199.281Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 207.419L87.9043 208.88V206.673L90.6766 205.212V207.419Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 130.577L93.6523 132.038V129.831L96.4239 128.37V130.577Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 73.8986L99.3994 75.3594V73.1531L102.172 71.6924V73.8986Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 77.9677L99.3994 79.4284V77.2215L102.172 75.7615V77.9677Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 82.038L99.3994 83.498V81.2918L102.172 79.8311V82.038Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 94.6652L99.3994 96.1252V93.919L102.172 92.4583V94.6652Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 86.5267L99.3994 87.9868V85.7799L102.172 84.3198V86.5267Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 53.3485L99.3994 54.8086V52.6024L102.172 51.1416V53.3485Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 61.4869L99.3994 62.947V60.7401L102.172 59.28V61.4869Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 57.4169L99.3994 58.8777V56.6714L102.172 55.2107V57.4169Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 65.556L99.3994 67.0161V64.8099L102.172 63.3491V65.556Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 69.7889L99.3994 71.2497V69.0428L102.172 67.582V69.7889Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 90.5961L99.3994 92.0561V89.8499L102.172 88.3892V90.5961Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 127.543L99.3994 129.004V126.798L102.172 125.337V127.543Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 119.405L99.3994 120.866V118.659L102.172 117.199V119.405Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 123.475L99.3994 124.935V122.729L102.172 121.268V123.475Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 131.613L99.3994 133.073V130.867L102.172 129.406V131.613Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 98.7343L99.3994 100.194V97.9881L102.172 96.5273V98.7343Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 135.682L99.3994 137.143V134.936L102.172 133.476V135.682Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 106.872L99.3994 108.332V106.126L102.172 104.666V106.872Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 102.803L99.3994 104.263V102.056L102.172 100.596V102.803Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 115.336L99.3994 116.797V114.59L102.172 113.13V115.336Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 111.267L99.3994 112.728V110.521L102.172 109.061V111.267Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 175.62L93.6523 177.081V174.874L96.4239 173.414V175.62Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 171.55L93.6523 173.011V170.804L96.4239 169.344V171.55Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 167.481L93.6523 168.942V166.735L96.4239 165.274V167.481Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 179.689L93.6523 181.15V178.943L96.4239 177.482V179.689Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 187.827L93.6523 189.288V187.081L96.4239 185.62V187.827Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 183.758L93.6523 185.219V183.012L96.4239 181.551V183.758Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 150.922L93.6523 152.383V150.176L96.4239 148.716V150.922Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 163.412L93.6523 164.873V162.666L96.4239 161.206V163.412Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 155.274L93.6523 156.735V154.528L96.4239 153.067V155.274Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 159.343L93.6523 160.804V158.597L96.4239 157.136V159.343Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 204.387L93.6523 205.847V203.641L96.4239 202.18V204.387Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 212.525L93.6523 213.985V211.779L96.4239 210.318V212.525Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 45.2103L99.3994 46.6704V44.4642L102.172 43.0034V45.2103Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 146.853L93.6523 148.313V146.107L96.4239 144.646V146.853Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 200.318L93.6523 201.779V199.572L96.4239 198.111V200.318Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 208.456L93.6523 209.916V207.71L96.4239 206.249V208.456Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 191.896L93.6523 193.357V191.15L96.4239 189.689V191.896Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4239 196.248L93.6523 197.708V195.502L96.4239 194.042V196.248Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 49.2794L99.3994 50.7395V48.5333L102.172 47.0725V49.2794Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 210.452L82.1553 211.913V209.706L84.9276 208.245V210.452Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 91.1349L82.1553 92.5956V90.3887L84.9276 88.928V91.1349Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 95.6239L82.1553 97.0847V94.8777L84.9276 93.417V95.6239Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 99.693L82.1553 101.154V98.9468L84.9276 97.4861V99.693Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 103.762L82.1553 105.223V103.016L84.9276 101.556V103.762Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 87.0658L82.1553 88.5266V86.3196L84.9276 84.8589V87.0658Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 74.6532L82.1553 76.114V73.9071L84.9276 72.447V74.6532Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 82.9967L82.1553 84.4575V82.2505L84.9276 80.7898V82.9967Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 107.832L82.1553 109.292V107.086L84.9276 105.625V107.832Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 70.5841L82.1553 72.0449V69.838L84.9276 68.3779V70.5841Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 78.8866L82.1553 80.3473V78.1404L84.9276 76.6797V78.8866Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 66.5151L82.1553 67.9758V65.7689L84.9276 64.3088V66.5151Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 111.901L82.1553 113.362V111.155L84.9276 109.695V111.901Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 136.641L82.1553 138.102V135.895L84.9276 134.435V136.641Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 148.849L82.1553 150.31V148.103L84.9276 146.642V148.849Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 132.572L82.1553 134.033V131.826L84.9276 130.365V132.572Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 144.78L82.1553 146.24V144.034L84.9276 142.573V144.78Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 140.711L82.1553 142.171V139.964L84.9276 138.504V140.711Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 128.503L82.1553 129.964V127.757L84.9276 126.296V128.503Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 115.97L82.1553 117.431V115.224L84.9276 113.764V115.97Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 120.365L82.1553 121.825V119.618L84.9276 118.158V120.365Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 124.434L82.1553 125.894V123.688L84.9276 122.227V124.434Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 62.4457L82.1553 63.9065V61.6995L84.9276 60.2395V62.4457Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 175.084L170.964 176.544V174.338L173.736 172.877V175.084Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 179.436L170.964 180.896V178.69L173.736 177.229V179.436Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 171.014L170.964 172.475V170.268L173.736 168.808V171.014Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 183.505L170.964 184.965V182.759L173.736 181.298V183.505Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 187.574L170.964 189.035V186.828L173.736 185.367V187.574Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 166.945L170.964 168.406V166.199L173.736 164.739V166.945Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 154.738L170.964 156.198V153.992L173.736 152.531V154.738Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 158.807L170.964 160.268V158.061L173.736 156.601V158.807Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 195.712L170.964 197.173V194.966L173.736 193.505V195.712Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 162.876L170.964 164.337V162.13L173.736 160.67V162.876Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 152.918L82.1553 154.379V152.172L84.9276 150.711V152.918Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 145.817L87.9043 147.277V145.07L90.6766 143.61V145.817Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 54.3075L82.1553 55.7683V53.5614L84.9276 52.1013V54.3075Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 58.3766L82.1553 59.8374V57.6305L84.9276 56.1704V58.3766Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 203.851L170.964 205.311V203.105L173.736 201.644V203.851Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 199.782L170.964 201.242V199.035L173.736 197.575V199.782Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 207.92L170.964 209.38V207.174L173.736 205.713V207.92Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 211.989L170.964 213.45V211.243L173.736 209.782V211.989Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 88.1027L87.9043 89.5634V87.3565L90.6766 85.8958V88.1027Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 84.0333L87.9043 85.4941V83.2872L90.6766 81.8264V84.0333Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 96.6608L87.9043 98.1215V95.9146L90.6766 94.4539V96.6608Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 92.5917L87.9043 94.0524V91.8455L90.6766 90.3848V92.5917Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 100.73L87.9043 102.191V99.9837L90.6766 98.5229V100.73Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 79.9642L87.9043 81.425V79.2181L90.6766 77.7573V79.9642Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 63.4825L87.9043 64.9433V62.7364L90.6766 61.2756V63.4825Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 67.5516L87.9043 69.0124V66.8055L90.6766 65.3447V67.5516Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 75.8544L87.9043 77.3144V75.1082L90.6766 73.6475V75.8544Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 71.6207L87.9043 73.0815V70.8746L90.6766 69.4138V71.6207Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 121.401L87.9043 122.862V120.655L90.6766 119.195V121.401Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 104.799L87.9043 106.26V104.053L90.6766 102.592V104.799Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 129.54L87.9043 131.001V128.794L90.6766 127.333V129.54Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 137.678L87.9043 139.139V136.932L90.6766 135.471V137.678Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 125.471L87.9043 126.931V124.724L90.6766 123.264V125.471Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 141.747L87.9043 143.208V141.001L90.6766 139.541V141.747Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 133.609L87.9043 135.07V132.863L90.6766 131.402V133.609Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 112.938L87.9043 114.398V112.191L90.6766 110.731V112.938Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 156.987L82.1553 158.448V156.241L84.9276 154.781V156.987Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 150.668L170.964 152.129V149.922L173.736 148.462V150.668Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 59.4135L87.9043 60.8742V58.6673L90.6766 57.2065V59.4135Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 108.868L87.9043 110.329V108.122L90.6766 106.661V108.868Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 185.755L82.1553 187.215V185.008L84.9276 183.548V185.755Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 181.685L82.1553 183.145V180.939L84.9276 179.479V181.685Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 193.893L82.1553 195.353V193.147L84.9276 191.686V193.893Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 189.824L82.1553 191.284V189.077L84.9276 187.617V189.824Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 197.962L82.1553 199.422V197.216L84.9276 195.755V197.962Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 177.616L82.1553 179.076V176.869L84.9276 175.409V177.616Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 161.339L82.1553 162.8V160.593L84.9276 159.133V161.339Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 55.3443L87.9043 56.805V54.5982L90.6766 53.1375V55.3443Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 173.547L82.1553 175.007V172.801L84.9276 171.34V173.547Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 169.477L82.1553 170.938V168.731L84.9276 167.271V169.477Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 165.408L82.1553 166.869V164.662L84.9276 163.202V165.408Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 51.275L87.9043 52.7358V50.5289L90.6766 49.0681V51.275Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 206.383L82.1553 207.843V205.637L84.9276 204.176V206.383Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 139.751L99.3994 141.212V139.006L102.172 137.545V139.751Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9276 202.313L82.1553 203.774V201.567L84.9276 200.106V202.313Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 117.332L87.9043 118.793V116.586L90.6766 115.125V117.332Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 140.105L33.9717 141.566V139.359L36.744 137.899V140.105Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 144.175L33.9717 145.635V143.429L36.744 141.969V144.175Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 148.527L33.9717 149.987V147.781L36.744 146.32V148.527Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 152.596L33.9717 154.056V151.85L36.744 150.389V152.596Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 156.665L33.9717 158.125V155.919L36.744 154.458V156.665Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 160.734L33.9717 162.194V159.988L36.744 158.527V160.734Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 119.759L33.9717 121.22V119.013L36.744 117.553V119.759Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 123.829L33.9717 125.29V123.083L36.744 121.623V123.829Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 127.898L33.9717 129.359V127.152L36.744 125.691V127.898Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 131.967L33.9717 133.428V131.221L36.744 129.761V131.967Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 136.036L33.9717 137.497V135.29L36.744 133.83V136.036Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 168.873L33.9717 170.333V168.127L36.744 166.666V168.873Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 164.803L33.9717 166.264V164.057L36.744 162.596V164.803Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 193.57L33.9717 195.031V192.824L36.744 191.364V193.57Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 189.501L33.9717 190.961V188.754L36.744 187.294V189.501Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 201.708L33.9717 203.169V200.962L36.744 199.502V201.708Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 197.639L33.9717 199.1V196.893L36.744 195.433V197.639Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 185.149L33.9717 186.61V184.403L36.744 182.942V185.149Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 115.69L33.9717 117.151V114.944L36.744 113.484V115.69Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 172.942L33.9717 174.403V172.196L36.744 170.735V172.942Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 177.011L33.9717 178.472V176.265L36.744 174.804V177.011Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 181.08L33.9717 182.541V180.334L36.744 178.873V181.08Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 212.879L28.2227 214.34V212.134L30.995 210.673V212.879Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 205.777L33.9717 207.238V205.031L36.744 203.571V205.777Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 188.182L28.2227 189.643V187.436L30.995 185.975V188.182Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 143.82L99.3994 145.281V143.075L102.172 141.614V143.82Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 192.533L28.2227 193.994V191.788L30.995 190.327V192.533Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 204.741L28.2227 206.201V203.994L30.995 202.534V204.741Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 196.602L28.2227 198.063V195.856L30.995 194.396V196.602Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 200.671L28.2227 202.132V199.926L30.995 198.465V200.671Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 98.8563L33.9717 100.316V98.1102L36.744 96.6494V98.8563Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 95.1888L33.9717 96.6496V94.4427L36.744 92.9819V95.1888Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 111.621L33.9717 113.082V110.875L36.744 109.415V111.621Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 107.552L33.9717 109.013V106.806L36.744 105.346V107.552Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 102.925L33.9717 104.385V102.179L36.744 100.719V102.925Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 208.81L28.2227 210.271V208.065L30.995 206.604V208.81Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 161.771L39.7197 163.231V161.024L42.492 159.564V161.771Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 165.84L39.7197 167.3V165.094L42.492 163.633V165.84Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 169.909L39.7197 171.369V169.163L42.492 167.702V169.909Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 178.048L39.7197 179.508V177.302L42.492 175.841V178.048Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 173.979L39.7197 175.439V173.232L42.492 171.772V173.979Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 153.633L39.7197 155.093V152.887L42.492 151.426V153.633Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 145.494L39.7197 146.954V144.748L42.492 143.287V145.494Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 157.702L39.7197 159.162V156.955L42.492 155.495V157.702Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 149.563L39.7197 151.023V148.817L42.492 147.356V149.563Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 182.117L39.7197 183.577V181.371L42.492 179.91V182.117Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 210.883L39.7197 212.344V210.137L42.492 208.677V210.883Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 141.142L39.7197 142.603V140.396L42.492 138.935V141.142Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 206.814L39.7197 208.275V206.068L42.492 204.607V206.814Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 194.607L39.7197 196.067V193.86L42.492 192.4V194.607Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 202.745L39.7197 204.206V201.999L42.492 200.538V202.745Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 190.537L39.7197 191.998V189.791L42.492 188.331V190.537Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 186.468L39.7197 187.929V185.722L42.492 184.261V186.468Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 198.676L39.7197 200.137V197.93L42.492 196.469V198.676Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 92.1564L39.7197 93.6164V91.4102L42.492 89.9495V92.1564Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.744 209.847L33.9717 211.307V209.1L36.744 207.64V209.847Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 137.073L39.7197 138.534V136.327L42.492 134.866V137.073Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 120.796L39.7197 122.257V120.05L42.492 118.589V120.796Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 124.865L39.7197 126.326V124.119L42.492 122.658V124.865Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 128.935L39.7197 130.396V128.189L42.492 126.728V128.935Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 116.727L39.7197 118.188V115.981L42.492 114.52V116.727Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 133.004L39.7197 134.465V132.258L42.492 130.797V133.004Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 108.589L39.7197 110.05V107.843L42.492 106.383V108.589Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 112.658L39.7197 114.119V111.912L42.492 110.451V112.658Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 104.52L39.7197 105.981V103.774L42.492 102.313V104.52Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 99.8932L39.7197 101.353V99.1463L42.492 97.6863V99.8932Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.492 95.8234L39.7197 97.2842V95.0772L42.492 93.6172V95.8234Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 125.825L22.4746 127.286V125.079L25.2477 123.618V125.825Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 104.921L22.4746 106.382V104.175L25.2477 102.714V104.921Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 108.99L22.4746 110.451V108.244L25.2477 106.783V108.99Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 117.687L22.4746 119.147V116.94L25.2477 115.48V117.687Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 121.756L22.4746 123.217V121.01L25.2477 119.549V121.756Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 113.618L22.4746 115.078V112.871L25.2477 111.411V113.618Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 170.868L22.4746 172.329V170.122L25.2477 168.662V170.868Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 101.254L22.4746 102.714V100.507L25.2477 99.0474V101.254Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 154.592L22.4746 156.052V153.846L25.2477 152.385V154.592Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 158.661L22.4746 160.122V157.915L25.2477 156.454V158.661Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 162.73L22.4746 164.191V161.984L25.2477 160.524V162.73Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 150.24L22.4746 151.701V149.494L25.2477 148.033V150.24Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 166.799L22.4746 168.26V166.053L25.2477 164.593V166.799Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 133.964L22.4746 135.424V133.217L25.2477 131.757V133.964Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 129.894L22.4746 131.355V129.148L25.2477 127.688V129.894Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 138.033L22.4746 139.493V137.286L25.2477 135.826V138.033Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 146.171L22.4746 147.631V145.425L25.2477 143.964V146.171Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 142.102L22.4746 143.562V141.356L25.2477 139.895V142.102Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 168.518L99.3994 169.979V167.772L102.172 166.311V168.518Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 172.587L99.3994 174.048V171.841L102.172 170.38V172.587Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 180.726L99.3994 182.186V179.98L102.172 178.519V180.726Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 176.656L99.3994 178.117V175.91L102.172 174.449V176.656Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 184.795L99.3994 186.256V184.049L102.172 182.588V184.795Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 152.241L99.3994 153.702V151.495L102.172 150.034V152.241Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 147.889L99.3994 149.35V147.144L102.172 145.683V147.889Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 156.31L99.3994 157.771V155.564L102.172 154.104V156.31Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 160.38L99.3994 161.841V159.634L102.172 158.173V160.38Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 164.449L99.3994 165.91V163.703L102.172 162.242V164.449Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 184.113L28.2227 185.573V183.367L30.995 181.906V184.113Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 209.492L99.3994 210.953V208.746L102.172 207.286V209.492Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 188.864L99.3994 190.325V188.118L102.172 186.657V188.864Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 193.215L99.3994 194.676V192.469L102.172 191.009V193.215Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 197.285L99.3994 198.745V196.538L102.172 195.078V197.285Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 201.354L99.3994 202.814V200.607L102.172 199.147V201.354Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 205.423L99.3994 206.884V204.677L102.172 203.217V205.423Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 122.793L28.2227 124.253V122.047L30.995 120.586V122.793Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 126.862L28.2227 128.322V126.116L30.995 124.655V126.862Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 135L28.2227 136.46V134.254L30.995 132.793V135Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 118.724L28.2227 120.184V117.977L30.995 116.517V118.724Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 130.931L28.2227 132.391V130.184L30.995 128.724V130.931Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 101.889L28.2227 103.35V101.143L30.995 99.6819V101.889Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 139.069L28.2227 140.53V138.323L30.995 136.863V139.069Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 105.958L28.2227 107.419V105.212L30.995 103.751V105.958Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 114.654L28.2227 116.114V113.908L30.995 112.448V114.654Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 110.585L28.2227 112.045V109.839L30.995 108.378V110.585Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 155.628L28.2227 157.089V154.882L30.995 153.421V155.628Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 167.836L28.2227 169.297V167.09L30.995 165.629V167.836Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 171.905L28.2227 173.366V171.159L30.995 169.698V171.905Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 163.767L28.2227 165.227V163.021L30.995 161.56V163.767Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 175.974L28.2227 177.435V175.228L30.995 173.767V175.974Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 180.043L28.2227 181.504V179.297L30.995 177.836V180.043Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 143.139L28.2227 144.599V142.392L30.995 140.932V143.139Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 159.698L28.2227 161.158V158.951L30.995 157.491V159.698Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 147.208L28.2227 148.668V146.462L30.995 145.001V147.208Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 151.559L28.2227 153.02V150.813L30.995 149.352V151.559Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 98.2211L28.2227 99.6819V97.4749L30.995 96.0149V98.2211Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 203.705L22.4746 205.165V202.959L25.2477 201.498V203.705Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 199.636L22.4746 201.096V198.889L25.2477 197.429V199.636Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 174.938L22.4746 176.398V174.191L25.2477 172.731V174.938Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 195.566L22.4746 197.026V194.82L25.2477 193.359V195.566Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 211.843L22.4746 213.303V211.097L25.2477 209.636V211.843Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 207.774L22.4746 209.235V207.028L25.2477 205.567V207.774Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 179.007L22.4746 180.467V178.261L25.2477 176.801V179.007Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 183.076L22.4746 184.537V182.33L25.2477 180.869V183.076Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 191.214L22.4746 192.675V190.468L25.2477 189.008V191.214Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2477 187.145L22.4746 188.606V186.399L25.2477 184.938V187.145Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 191.643L170.964 193.104V190.897L173.736 189.436V191.643Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 212.65L280.665 214.111V211.905L283.437 210.444V212.65Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 62.5624L286.413 64.0232V61.817L289.185 60.3562V62.5624Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 192.305L280.665 193.765V191.559L283.437 190.098V192.305Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 66.6322L286.413 68.0923V65.886L289.185 64.4253V66.6322Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 196.374L280.665 197.834V195.627L283.437 194.167V196.374Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 188.236L280.665 189.696V187.49L283.437 186.029V188.236Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 204.512L280.665 205.973V203.766L283.437 202.306V204.512Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 208.581L280.665 210.042V207.836L283.437 206.375V208.581Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 200.443L280.665 201.903V199.697L283.437 198.236V200.443Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 99.185L286.413 100.646V98.4388L289.185 96.9788V99.185Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 95.1156L286.413 96.5764V94.3695L289.185 92.9094V95.1156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 103.254L286.413 104.715V102.508L289.185 101.048V103.254Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 91.0472L286.413 92.5073V90.3011L289.185 88.8403V91.0472Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 107.323L286.413 108.784V106.577L289.185 105.117V107.323Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 86.9782L286.413 88.4382V86.232L289.185 84.7712V86.9782Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 74.7697L286.413 76.2304V74.0242L289.185 72.5635V74.7697Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 70.7006L286.413 72.1614V69.9544L289.185 68.4944V70.7006Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 78.839L286.413 80.2998V78.0929L289.185 76.6328V78.839Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 82.9088L286.413 84.3689V82.1627L289.185 80.7019V82.9088Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 118.495L280.665 119.955V117.748L283.437 116.288V118.495Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 122.564L280.665 124.024V121.818L283.437 120.357V122.564Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 126.633L280.665 128.093V125.887L283.437 124.426V126.633Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 111.392L286.413 112.853V110.646L289.185 109.186V111.392Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 130.702L280.665 132.162V129.956L283.437 128.495V130.702Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 184.167L280.665 185.627V183.42L283.437 181.96V184.167Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 139.123L280.665 140.583V138.377L283.437 136.916V139.123Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 114.425L280.665 115.885V113.679L283.437 112.219V114.425Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 102.218L280.665 103.678V101.472L283.437 100.011V102.218Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 106.287L280.665 107.747V105.541L283.437 104.08V106.287Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 110.356L280.665 111.816V109.61L283.437 108.149V110.356Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 134.771L280.665 136.231V134.025L283.437 132.564V134.771Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 171.676L280.665 173.137V170.93L283.437 169.469V171.676Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 167.607L280.665 169.068V166.861L283.437 165.4V167.607Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 175.745L280.665 177.206V174.999L283.437 173.539V175.745Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 143.192L280.665 144.653V142.446L283.437 140.985V143.192Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 163.538L280.665 164.998V162.792L283.437 161.331V163.538Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 180.097L280.665 181.558V179.351L283.437 177.891V180.097Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 151.33L280.665 152.791V150.584L283.437 149.124V151.33Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 147.261L280.665 148.722V146.515L283.437 145.054V147.261Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 159.469L280.665 160.929V158.722L283.437 157.262V159.469Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 155.4L280.665 156.86V154.653L283.437 153.193V155.4Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 100.319L217.916 101.78V99.5731L220.688 98.113V100.319Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 55.5582L217.916 57.019V54.8121L220.688 53.3513V55.5582Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 51.4892L217.916 52.9499V50.743L220.688 49.283V51.4892Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 59.6274L217.916 61.0881V58.8812L220.688 57.4211V59.6274Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 67.7658L217.916 69.2265V67.0196L220.688 65.5588V67.7658Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 63.6964L217.916 65.1572V62.9503L220.688 61.4902V63.6964Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 209.618L286.413 211.079V208.872L289.185 207.412V209.618Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 205.549L286.413 207.009V204.803L289.185 203.343V205.549Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 96.2501L217.916 97.7109V95.504L220.688 94.0432V96.2501Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 98.1491L280.665 99.6091V97.4029L283.437 95.9421V98.1491Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 108.783L217.916 110.244V108.037L220.688 106.576V108.783Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 115.462L286.413 116.922V114.715L289.185 113.255V115.462Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 71.8351L217.916 73.2959V71.089L220.688 69.6289V71.8351Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 104.714L217.916 106.175V103.968L220.688 102.507V104.714Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 88.1117L217.916 89.5725V87.3656L220.688 85.9055V88.1117Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 79.9733L217.916 81.4341V79.2271L220.688 77.7671V79.9733Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 75.9042L217.916 77.3649V75.158L220.688 73.6973V75.9042Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 84.0424L217.916 85.5031V83.2962L220.688 81.8362V84.0424Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 92.181L217.916 93.6418V91.4349L220.688 89.9741V92.181Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 136.09L286.413 137.551V135.344L289.185 133.884V136.09Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 144.229L286.413 145.689V143.482L289.185 142.022V144.229Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 140.16L286.413 141.62V139.413L289.185 137.953V140.16Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 148.298L286.413 149.758V147.552L289.185 146.091V148.298Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 152.367L286.413 153.828V151.621L289.185 150.16V152.367Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 131.738L286.413 133.199V130.992L289.185 129.532V131.738Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 119.531L286.413 120.991V118.785L289.185 117.324V119.531Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 123.6L286.413 125.061V122.854L289.185 121.394V123.6Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 127.669L286.413 129.13V126.923L289.185 125.463V127.669Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 156.436L286.413 157.897V155.69L289.185 154.229V156.436Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 197.41L286.413 198.871V196.664L289.185 195.204V197.41Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 185.203L286.413 186.664V184.457L289.185 182.997V185.203Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 189.272L286.413 190.733V188.526L289.185 187.066V189.272Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 181.134L286.413 182.594V180.388L289.185 178.927V181.134Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 201.48L286.413 202.94V200.733L289.185 199.273V201.48Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 193.341L286.413 194.802V192.595L289.185 191.135V193.341Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 172.713L286.413 174.173V171.967L289.185 170.506V172.713Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 177.064L286.413 178.525V176.318L289.185 174.857V177.064Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 168.644L286.413 170.104V167.898L289.185 166.437V168.644Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 164.575L286.413 166.035V163.828L289.185 162.368V164.575Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 160.505L286.413 161.966V159.759L289.185 158.299V160.505Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 184.084L322.881 182.623V180.417L325.652 181.877V184.084Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 197.61L317.133 196.15V193.943L319.905 195.403V197.61Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 181.051L317.133 179.591V177.384L319.905 178.845V181.051Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 193.541L317.133 192.081V189.874L319.905 191.335V193.541Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 189.19L317.133 187.729V185.522L319.905 186.983V189.19Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 152.567L317.133 151.106V148.899L319.905 150.36V152.567Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 156.636L317.133 155.176V152.969L319.905 154.43V156.636Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 160.706L317.133 159.245V157.038L319.905 158.499V160.706Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 168.844L317.133 167.383V165.176L319.905 166.637V168.844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 164.775L317.133 163.314V161.107L319.905 162.568V164.775Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 172.913L317.133 171.452V169.246L319.905 170.706V172.913Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 185.121L317.133 183.66V181.453L319.905 182.914V185.121Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 201.68L317.133 200.22V198.013L319.905 199.473V201.68Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 209.818L317.133 208.358V206.151L319.905 207.612V209.818Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 205.749L317.133 204.289V202.082L319.905 203.543V205.749Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 213.887L317.133 212.427V210.22L319.905 211.681V213.887Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 176.982L317.133 175.522V173.315L319.905 174.775V176.982Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 99.0591L317.133 97.599V95.3921L319.905 96.8528V99.0591Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 103.129L317.133 101.669V99.4617L319.905 100.922V103.129Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 94.99L317.133 93.5299V91.323L319.905 92.7838V94.99Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 119.731L317.133 118.271V116.064L319.905 117.525V119.731Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 136.008L317.133 134.547V132.341L319.905 133.801V136.008Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 131.938L317.133 130.478V128.271L319.905 129.732V131.938Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 144.146L317.133 142.686V140.479L319.905 141.94V144.146Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 127.869L317.133 126.409V124.202L319.905 125.663V127.869Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 140.077L317.133 138.617V136.41L319.905 137.871V140.077Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 111.593L317.133 110.132V107.926L319.905 109.386V111.593Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 115.662L317.133 114.202V111.995L319.905 113.455V115.662Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 107.198L317.133 105.738V103.531L319.905 104.992V107.198Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 148.215L317.133 146.755V144.548L319.905 146.008V148.215Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.905 123.8L317.133 122.34V120.133L319.905 121.594V123.8Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 139.04L322.881 137.58V135.373L325.652 136.834V139.04Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 208.781L322.881 207.321V205.114L325.652 206.575V208.781Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 204.712L322.881 203.252V201.045L325.652 202.506V204.712Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 212.851L322.881 211.39V209.183L325.652 210.644V212.851Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 200.643L322.881 199.183V196.976L325.652 198.437V200.643Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 196.574L322.881 195.114V192.907L325.652 194.368V196.574Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 112.853L217.916 114.313V112.106L220.688 110.646V112.853Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 188.153L322.881 186.692V184.486L325.652 185.946V188.153Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 192.222L322.881 190.762V188.555L325.652 190.015V192.222Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 90.0104L280.665 91.4711V89.2642L283.437 87.8035V90.0104Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 81.8722L280.665 83.3323V81.126L283.437 79.6653V81.8722Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 85.9413L280.665 87.4013V85.1951L283.437 83.7344V85.9413Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 180.015L322.881 178.554V176.348L325.652 177.808V180.015Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 73.7338L280.665 75.1945V72.9876L283.437 71.5269V73.7338Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 77.8031L280.665 79.2632V77.0569L283.437 75.5962V77.8031Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 69.6644L280.665 71.1245V68.9183L283.437 67.4575V69.6644Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 65.5953L280.665 67.0554V64.8492L283.437 63.3884V65.5953Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.185 58.5446L286.413 60.0046V57.7984L289.185 56.3376V58.5446Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 61.5768L280.665 63.0375V60.8306L283.437 59.3699V61.5768Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 167.807L322.881 166.346V164.14L325.652 165.6V167.807Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 110.231L322.881 108.77V106.563L325.652 108.024V110.231Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 114.626L322.881 113.165V110.958L325.652 112.419V114.626Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 118.695L322.881 117.234V115.027L325.652 116.488V118.695Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 126.833L322.881 125.372V123.166L325.652 124.626V126.833Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 122.764L322.881 121.303V119.096L325.652 120.557V122.764Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 130.902L322.881 129.442V127.235L325.652 128.695V130.902Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 98.0234L322.881 96.5626V94.3557L325.652 95.8165V98.0234Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 106.161L322.881 104.701V102.494L325.652 103.955V106.161Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 102.092L322.881 100.632V98.4248L325.652 99.8855V102.092Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 151.248L322.881 149.787V147.581L325.652 149.041V151.248Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 155.6L322.881 154.139V151.932L325.652 153.393V155.6Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 163.738L322.881 162.277V160.071L325.652 161.531V163.738Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 159.669L322.881 158.208V156.002L325.652 157.462V159.669Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 134.971L322.881 133.511V131.304L325.652 132.764V134.971Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 171.876L322.881 170.416V168.209L325.652 169.67V171.876Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.437 94.0795L280.665 95.5402V93.3333L283.437 91.8726V94.0795Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 143.11L322.881 141.649V139.442L325.652 140.903V143.11Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 147.179L322.881 145.718V143.511L325.652 144.972V147.179Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.652 175.946L322.881 174.485V172.279L325.652 173.739V175.946Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 121.902L170.964 123.363V121.156L173.736 119.695V121.902Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 192.806L229.413 194.266V192.059L232.185 190.599V192.806Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 71.7528L165.216 73.2129V71.0066L167.988 69.5459V71.7528Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 205.013L229.413 206.473V204.266L232.185 202.806V205.013Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 196.874L229.413 198.335V196.128L232.185 194.668V196.874Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 200.944L229.413 202.404V200.198L232.185 198.737V200.944Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 209.082L229.413 210.542V208.335L232.185 206.875V209.082Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 80.1735L165.216 81.6342V79.4273L167.988 77.9666V80.1735Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 76.1044L165.216 77.5651V75.3582L167.988 73.8975V76.1044Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 108.658L165.216 110.118V107.911L167.988 106.451V108.658Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 112.727L165.216 114.187V111.981L167.988 110.52V112.727Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 104.589L165.216 106.049V103.842L167.988 102.382V104.589Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 120.865L165.216 122.326V120.119L167.988 118.658V120.865Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 84.2426L165.216 85.7033V83.4964L167.988 82.0356V84.2426Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 116.922L217.916 118.383V116.176L220.688 114.716V116.922Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 88.3117L165.216 89.7724V87.5655L167.988 86.1047V88.3117Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 92.3808L165.216 93.8415V91.6346L167.988 90.1746V92.3808Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 96.4503L165.216 97.9111V95.7042L167.988 94.2434V96.4503Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 100.519L165.216 101.98V99.7733L167.988 98.3125V100.519Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 143.693L229.413 145.153V142.946L232.185 141.486V143.693Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 127.133L229.413 128.593V126.387L232.185 124.927V127.133Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 131.203L229.413 132.663V130.457L232.185 128.996V131.203Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 135.272L229.413 136.732V134.526L232.185 133.065V135.272Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 139.623L229.413 141.084V138.877L232.185 137.417V139.623Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 102.718L229.413 104.178V101.972L232.185 100.511V102.718Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 123.064L229.413 124.524V122.318L232.185 120.857V123.064Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 110.857L229.413 112.318V110.111L232.185 108.65V110.857Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 188.736L229.413 190.196V187.99L232.185 186.529V188.736Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 114.926L229.413 116.386V114.18L232.185 112.719V114.926Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 118.995L229.413 120.455V118.249L232.185 116.788V118.995Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 106.788L229.413 108.248V106.042L232.185 104.581V106.788Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 176.246L229.413 177.707V175.5L232.185 174.039V176.246Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 172.177L229.413 173.637V171.43L232.185 169.97V172.177Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 184.667L229.413 186.127V183.921L232.185 182.46V184.667Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 180.597L229.413 182.058V179.852L232.185 178.391V180.597Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 168.108L229.413 169.568V167.361L232.185 165.901V168.108Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 155.9L229.413 157.361V155.154L232.185 153.693V155.9Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 164.038L229.413 165.499V163.292L232.185 161.831V164.038Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 151.831L229.413 153.292V151.085L232.185 149.624V151.831Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 147.762L229.413 149.222V147.015L232.185 145.555V147.762Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 159.969L229.413 161.43V159.223L232.185 157.762V159.969Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 124.934L165.216 126.395V124.188L167.988 122.728V124.934Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 85.2794L170.964 86.7402V84.5333L173.736 83.0725V85.2794Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 101.556L170.964 103.017V100.81L173.736 99.3491V101.556Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 89.3485L170.964 90.8093V88.6024L173.736 87.1416V89.3485Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 97.4869L170.964 98.9477V96.7408L173.736 95.28V97.4869Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 93.4176L170.964 94.8784V92.6714L173.736 91.2107V93.4176Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 81.2101L170.964 82.6708V80.4639L173.736 79.0032V81.2101Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 68.7199L170.964 70.1806V67.9737L173.736 66.5137V68.7199Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 73.0719L170.964 74.5327V72.3257L173.736 70.865V73.0719Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 77.141L170.964 78.6017V76.3948L173.736 74.9341V77.141Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 125.971L170.964 127.432V125.225L173.736 123.764V125.971Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 105.625L170.964 107.086V104.879L173.736 103.418V105.625Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 134.11L170.964 135.57V133.363L173.736 131.903V134.11Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 138.461L170.964 139.922V137.715L173.736 136.255V138.461Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 142.53L170.964 143.991V141.784L173.736 140.324V142.53Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 130.04L170.964 131.5V129.294L173.736 127.833V130.04Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 146.599L170.964 148.06V145.853L173.736 144.393V146.599Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 113.764L170.964 115.224V113.017L173.736 111.557V113.764Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 109.694L170.964 111.155V108.948L173.736 107.488V109.694Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.736 117.833L170.964 119.293V117.086L173.736 115.626V117.833Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 206.883L165.216 208.344V206.137L167.988 204.676V206.883Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 157.77L165.216 159.231V157.024L167.988 155.564V157.77Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 153.701L165.216 155.162V152.955L167.988 151.495V153.701Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 165.909L165.216 167.369V165.163L167.988 163.702V165.909Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 149.632L165.216 151.092V148.886L167.988 147.426V149.632Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 161.84L165.216 163.3V161.094L167.988 159.633V161.84Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 133.073L165.216 134.533V132.326L167.988 130.866V133.073Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 137.142L165.216 138.602V136.396L167.988 134.935V137.142Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 169.978L165.216 171.438V169.232L167.988 167.771V169.978Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 141.494L165.216 142.954V140.748L167.988 139.287V141.494Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 145.563L165.216 147.023V144.817L167.988 143.356V145.563Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 129.004L165.216 130.464V128.257L167.988 126.797V129.004Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 198.745L165.216 200.206V197.999L167.988 196.538V198.745Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 202.814L165.216 204.275V202.068L167.988 200.607V202.814Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 174.047L165.216 175.508V173.301L167.988 171.841V174.047Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 210.952L165.216 212.413V210.206L167.988 208.745V210.952Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 194.675L165.216 196.136V193.929L167.988 192.469V194.675Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 182.468L165.216 183.929V181.722L167.988 180.261V182.468Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 190.606L165.216 192.067V189.86L167.988 188.399V190.606Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 178.116L165.216 179.577V177.37L167.988 175.91V178.116Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 186.537L165.216 187.998V185.791L167.988 184.33V186.537Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.988 116.796L165.216 118.257V116.05L167.988 114.589V116.796Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 60.6642L223.665 62.1249V59.918L226.437 58.4573V60.6642Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 48.4569L223.665 49.9177V47.7107L226.437 46.25V48.4569Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 56.5951L223.665 58.0558V55.8489L226.437 54.3882V56.5951Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 52.526L223.665 53.9868V51.7798L226.437 50.3191V52.526Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 207.009L217.916 208.469V206.263L220.688 204.802V207.009Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 211.078L217.916 212.539V210.332L220.688 208.871V211.078Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 85.0792L223.665 86.54V84.3331L226.437 82.8723V85.0792Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 93.2177L223.665 94.6784V92.4715L226.437 91.0107V93.2177Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 89.1483L223.665 90.6091V88.4022L226.437 86.9414V89.1483Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 101.682L223.665 103.143V100.936L226.437 99.4749V101.682Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 97.287L223.665 98.7477V96.5408L226.437 95.0801V97.287Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 72.872L223.665 74.3327V72.1258L226.437 70.665V72.872Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 68.8024L223.665 70.2631V68.0562L226.437 66.5955V68.8024Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 64.7333L223.665 66.194V63.9871L226.437 62.5264V64.7333Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 76.941L223.665 78.4018V76.1949L226.437 74.7341V76.941Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 81.0101L223.665 82.4709V80.264L226.437 78.8032V81.0101Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 149.758L217.916 151.218V149.012L220.688 147.551V149.758Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 137.268L217.916 138.728V136.522L220.688 135.061V137.268Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 157.896L217.916 159.356V157.15L220.688 155.689V157.896Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 141.337L217.916 142.798V140.591L220.688 139.13V141.337Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 105.751L223.665 107.212V105.005L226.437 103.544V105.751Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 153.827L217.916 155.287V153.081L220.688 151.62V153.827Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 145.689L217.916 147.149V144.943L220.688 143.482V145.689Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 120.991L217.916 122.452V120.245L220.688 118.784V120.991Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 133.198L217.916 134.659V132.452L220.688 130.991V133.198Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 125.06L217.916 126.521V124.314L220.688 122.853V125.06Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 129.129L217.916 130.59V128.383L220.688 126.922V129.129Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 182.311L217.916 183.771V181.565L220.688 180.104V182.311Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 186.663L217.916 188.123V185.917L220.688 184.456V186.663Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 202.939L217.916 204.4V202.193L220.688 200.732V202.939Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 161.966L217.916 163.426V161.22L220.688 159.759V161.966Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 194.801L217.916 196.262V194.055L220.688 192.594V194.801Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 198.87L217.916 200.331V198.124L220.688 196.663V198.87Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 190.732L217.916 192.193V189.986L220.688 188.525V190.732Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 178.242L217.916 179.702V177.495L220.688 176.035V178.242Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 166.034L217.916 167.495V165.289L220.688 163.828V166.034Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 170.104L217.916 171.564V169.358L220.688 167.897V170.104Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.688 174.173L217.916 175.633V173.427L220.688 171.966V174.173Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 126.097L223.665 127.558V125.351L226.437 123.89V126.097Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 45.4242L229.413 46.8843V44.678L232.185 43.2173V45.4242Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 49.4935L229.413 50.9536V48.7474L232.185 47.2866V49.4935Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 53.5626L229.413 55.0234V52.8165L232.185 51.3557V53.5626Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 203.976L223.665 205.436V203.23L226.437 201.769V203.976Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 208.045L223.665 209.506V207.299L226.437 205.838V208.045Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 212.114L223.665 213.575V211.368L226.437 209.907V212.114Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 82.047L229.413 83.5078V81.3008L232.185 79.8401V82.047Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 77.9777L229.413 79.4384V77.2315L232.185 75.7708V77.9777Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 86.1161L229.413 87.5768V85.3699L232.185 83.9092V86.1161Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 199.907L223.665 201.368V199.161L226.437 197.7V199.907Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 94.2543L229.413 95.7143V93.5081L232.185 92.0474V94.2543Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 90.1852L229.413 91.6459V89.439L232.185 87.9783V90.1852Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 57.632L229.413 59.092V56.8858L232.185 55.425V57.632Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 61.7011L229.413 63.1618V60.9549L232.185 59.4941V61.7011Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 65.7702L229.413 67.2309V65.024L232.185 63.5632V65.7702Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 69.8392L229.413 71.3V69.0931L232.185 67.6323V69.8392Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 73.9086L229.413 75.3686V73.1624L232.185 71.7017V73.9086Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 122.028L223.665 123.488V121.282L226.437 119.821V122.028Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 134.235L223.665 135.696V133.489L226.437 132.028V134.235Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 150.795L223.665 152.255V150.048L226.437 148.588V150.795Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 142.656L223.665 144.116V141.91L226.437 140.449V142.656Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 130.166L223.665 131.627V129.42L226.437 127.959V130.166Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 146.725L223.665 148.186V145.979L226.437 144.519V146.725Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 138.304L223.665 139.765V137.558L226.437 136.097V138.304Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 113.889L223.665 115.35V113.143L226.437 111.682V113.889Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.185 98.6493L229.413 100.109V97.9031L232.185 96.4424V98.6493Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 117.958L223.665 119.419V117.212L226.437 115.751V117.958Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 109.82L223.665 111.281V109.074L226.437 107.613V109.82Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 175.209L223.665 176.67V174.463L226.437 173.002V175.209Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 195.838L223.665 197.298V195.092L226.437 193.631V195.838Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 179.278L223.665 180.739V178.533L226.437 177.071V179.278Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 183.63L223.665 185.091V182.884L226.437 181.423V183.63Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 187.699L223.665 189.159V186.953L226.437 185.492V187.699Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 191.769L223.665 193.23V191.023L226.437 189.562V191.769Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 163.002L223.665 164.462V162.255L226.437 160.795V163.002Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 154.863L223.665 156.324V154.117L226.437 152.657V154.863Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 171.14L223.665 172.601V170.394L226.437 168.934V171.14Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 158.932L223.665 160.393V158.186L226.437 156.726V158.932Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.437 167.071L223.665 168.531V166.325L226.437 164.865V167.071Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.622 89.5212L336.208 79.2026L346 84.3619L326.415 94.6805L316.622 89.5212Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.861 48.2608L274.195 39.6641L293.781 49.9827L277.446 58.5794L257.861 48.2608Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.773 64.667V74.9772L303.566 69.8256L293.773 64.667Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.582 38.8035L212.168 28.4863L235.016 40.5247L215.431 50.8419L192.582 38.8035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2764 45.5746L94.655 30.0959L107.71 36.9764L78.3318 52.455L65.2764 45.5746Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 89.7579L26.0986 75.9949L45.7064 86.3233L19.6085 100.086L0 89.7579Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.878 61.1338L159.937 54.252L176.265 62.8522L163.206 69.7348L146.878 61.1338Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.709 53.0469L120.768 46.1643L133.829 53.0434L120.771 59.9252L107.709 53.0469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.019 79.9846V90.2948L244.811 85.1432L235.019 79.9846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2758 108.241V97.9307L55.4834 103.082L65.2758 108.241Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 242.925L112.19 274.962L173 307L233.809 274.963L173 242.925Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.714 136.186L195.059 137.585L197.714 138.984L200.369 137.585L197.714 136.186Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.369 137.585L222.849 274.981L220.193 276.379L197.714 138.984L200.369 137.585Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.059 137.585L217.539 274.981L220.193 276.379L197.714 138.984L195.059 137.585Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.276 136.186L150.931 137.585L148.276 138.984L145.621 137.585L148.276 136.186Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.621 137.585L123.15 274.981L125.806 276.379L148.276 138.984L145.621 137.585Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.931 137.585L128.46 274.981L125.806 276.379L148.276 138.984L150.931 137.585Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 283.882V281.084L170.345 282.483V285.281L173 283.882Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.344 285.281L127.03 262.52L127.26 259.839L170.344 282.484V285.281Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 281.084L129.915 258.44L127.26 259.839L170.344 282.483L172.999 281.084Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.344 234.396L172.999 235.795L170.344 237.194L167.689 235.795L170.344 234.396Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69 235.795L127.261 259.839L129.916 261.238L170.345 237.194L167.69 235.795Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 235.795L132.571 259.839L129.916 261.238L170.345 237.194L173 235.795Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.881 217.344L135.227 218.743L137.881 220.141L140.537 218.743L137.881 217.344Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.537 218.743L173 281.084L170.345 282.483L137.882 220.141L140.537 218.743Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69 235.795L149.869 246.389L151.128 248.618L170.345 237.194L167.69 235.795Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.227 218.743L167.69 281.084L170.344 282.483L137.881 220.141L135.227 218.743Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 235.795V232.997L170.345 234.396V237.194L173 235.795Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.344 237.194L135.227 218.743L135.648 216.161L170.344 234.396V237.194Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 232.998L138.304 214.762L135.648 216.161L170.345 234.396L173 232.998Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.344 190.562L172.999 191.961L170.344 193.359L167.689 191.961L170.344 190.562Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.689 191.961L135.647 216.162L138.303 217.561L170.344 193.36L167.689 191.961Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 191.961L140.958 216.162L138.303 217.561L170.344 193.36L172.999 191.961Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.681 177.082L141.831 178.38L144.681 179.879L147.336 178.481L144.681 177.082Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.336 178.48L173 232.998L170.345 234.396L144.682 179.879L147.336 178.48Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69 191.961L154.911 201.612L156.087 204.128L170.344 193.36L167.69 191.961Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.831 178.38L167.69 232.998L170.344 234.396L144.681 179.879L141.831 178.38Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 283.882V281.084L175.654 282.483V285.28L172.999 283.882Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.654 285.281L218.968 262.519L218.738 259.839L175.654 282.483V285.281Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 281.084L216.083 258.439L218.738 259.838L175.654 282.483L172.999 281.084Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.653 234.396L172.998 235.795L175.653 237.194L178.308 235.795L175.653 234.396Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.308 235.795L218.737 259.839L216.082 261.238L175.653 237.194L178.308 235.795Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.998 235.795L213.427 259.839L216.082 261.238L175.653 237.194L172.998 235.795Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1 217.307L210.763 218.728L208.108 220.127L205.444 218.706L208.1 217.307Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.444 218.706L172.998 281.084L175.653 282.483L208.108 220.127L205.444 218.706Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.308 235.795L196.128 246.389L194.87 248.618L175.653 237.194L178.308 235.795Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.763 218.728L178.308 281.084L175.653 282.483L208.108 220.127L210.763 218.728Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 235.795V232.998L175.654 234.396V237.194L172.999 235.795Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.654 237.194L210.764 218.728L210.334 216.132L175.654 234.396V237.194Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 232.998L207.679 214.733L210.335 216.132L175.654 234.396L172.999 232.998Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 191.961V189.163L170.345 190.562V193.36L173 191.961Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.344 193.359L141.831 178.38L142.256 175.8L170.344 190.561V193.359Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 189.163L144.91 174.401L142.255 175.8L170.343 190.562L172.999 189.163Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.345 150.608L173 152.006L170.345 153.405L167.69 152.006L170.345 150.608Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69 152.007L142.256 175.8L144.911 177.199L170.344 153.406L167.69 152.007Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 152.007L147.566 175.8L144.911 177.199L170.344 153.406L173 152.007Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.689 140.255L148.033 141.654L150.689 143.052L153.343 141.654L150.689 140.255Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.343 141.654L172.999 189.162L170.344 190.561L150.688 143.052L153.343 141.654Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69 152.007L158.104 160.975L159.262 163.774L170.344 153.406L167.69 152.007Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.033 141.654L167.689 189.162L170.344 190.561L150.689 143.052L148.033 141.654Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.654 190.562L172.999 191.961L175.654 193.359L178.309 191.961L175.654 190.562Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.309 191.961L210.334 216.132L207.857 217.434L175.654 193.36L178.309 191.961Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 191.961L205.201 216.035L207.857 217.434L175.654 193.36L172.999 191.961Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.504 176.977L204.159 178.376L201.504 179.774L198.849 178.376L201.504 176.977Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.848 178.376L172.999 232.998L175.654 234.396L201.504 179.774L198.848 178.376Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.309 191.961L191.15 201.652L190 204.083L175.654 193.36L178.309 191.961Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.159 178.376L178.309 232.998L175.654 234.396L201.504 179.774L204.159 178.376Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 191.961V189.163L175.654 190.562V193.36L172.999 191.961Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.654 193.36L204.159 178.376L203.724 175.793L175.654 190.562V193.36Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 189.163L201.068 174.394L203.724 175.793L175.654 190.561L172.999 189.163Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.654 150.608L172.999 152.006L175.654 153.405L178.309 152.006L175.654 150.608Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.309 152.006L203.741 175.797L201.085 177.196L175.654 153.405L178.309 152.006Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 152.006L198.431 175.797L201.085 177.196L175.654 153.405L172.999 152.006Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.31 140.278L197.965 141.677L195.31 143.076L192.654 141.677L195.31 140.278Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.654 141.677L172.999 189.162L175.654 190.561L195.31 143.075L192.654 141.677Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.309 152.006L187.896 160.976L186.741 163.777L175.654 153.405L178.309 152.006Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.965 141.677L178.309 189.162L175.654 190.561L195.31 143.075L197.965 141.677Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 152.007V149.209L170.345 150.608V153.405L173 152.007Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.345 153.405L145.199 140.164L145.622 137.585L170.345 150.608V153.405Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 149.209L148.276 136.186L145.621 137.585L170.344 150.608L173 149.209Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 152.007V149.209L175.654 150.608V153.405L172.999 152.007Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.654 153.405L200.598 140.265L200.369 137.585L175.654 150.608V153.405Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 149.209L197.714 136.186L200.369 137.585L175.654 150.608L172.999 149.209Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.999 149.209L170.344 150.608L172.999 152.007L175.655 150.608L172.999 149.209Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.654 150.608V299.847L172.999 301.246V152.007L175.654 150.608Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.344 150.608V299.847L172.999 301.246V152.007L170.344 150.608Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.996 120.486L145.622 134.909L172.996 149.331L200.37 134.909L172.996 120.486Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.996 120.486L145.622 134.909L172.996 149.331L200.37 134.909L172.996 120.486Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37 134.909L200.371 137.585L172.997 152.006L172.996 149.331L200.37 134.909Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.37 134.909L200.371 137.585L172.997 152.006L172.996 149.331L200.37 134.909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.622 134.908V137.585L172.997 152.006L172.996 149.331L145.622 134.908Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M145.622 134.908V137.585L172.997 152.006L172.996 149.331L145.622 134.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.954 181.856C221.573 180.824 223.706 173.979 221.718 166.568C219.729 159.157 214.373 153.985 209.753 155.018C205.134 156.05 203.001 162.894 204.989 170.305C206.977 177.717 212.334 182.888 216.954 181.856Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M222.31 169.661C222.281 169.787 222.253 169.914 222.22 170.039C221.516 172.711 219.749 175.248 217.066 176.495C214.789 177.552 212.056 177.59 209.595 176.966C208.909 176.791 208.242 176.568 207.592 176.307C208.294 177.406 209.094 178.406 209.981 179.262C214.653 183.773 219.95 182.59 221.81 176.62C222.465 174.519 222.605 172.104 222.31 169.661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.821 175.084C209.679 174.893 210.398 174.184 210.776 173.002C211.531 170.639 210.63 167.282 208.765 165.505C207.833 164.616 206.836 164.291 205.978 164.482C205.457 164.599 205.366 164.618 204.845 164.735C203.987 164.926 203.268 165.636 202.89 166.818C202.135 169.18 203.036 172.537 204.901 174.314C205.833 175.203 206.831 175.529 207.688 175.337C208.209 175.221 208.299 175.201 208.821 175.084Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M208.821 175.084C209.679 174.893 210.398 174.184 210.776 173.002C211.531 170.639 210.63 167.282 208.765 165.505C207.833 164.616 206.836 164.291 205.978 164.482C205.457 164.599 205.366 164.618 204.845 164.735C203.987 164.926 203.268 165.636 202.89 166.818C202.135 169.18 203.036 172.537 204.901 174.314C205.833 175.203 206.831 175.529 207.688 175.337C208.209 175.221 208.299 175.201 208.821 175.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.776 173.002C211.04 172.176 211.097 171.228 210.986 170.27L203.331 171.98C203.718 172.877 204.249 173.694 204.9 174.316C205.833 175.204 206.83 175.53 207.688 175.338C208.209 175.222 208.3 175.202 208.82 175.086C209.68 174.893 210.399 174.184 210.776 173.002Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.764 165.506C207.832 164.617 206.834 164.291 205.976 164.483C205.118 164.675 204.398 165.384 204.021 166.566C203.266 168.928 204.167 172.285 206.032 174.062C206.964 174.951 207.962 175.277 208.819 175.085C209.678 174.893 210.397 174.184 210.775 173.002C211.529 170.64 210.629 167.283 208.764 165.506Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M208.764 165.506C207.832 164.617 206.834 164.291 205.976 164.483C205.118 164.675 204.398 165.384 204.021 166.566C203.266 168.928 204.167 172.285 206.032 174.062C206.964 174.951 207.962 175.277 208.819 175.085C209.678 174.893 210.397 174.184 210.775 173.002C211.529 170.64 210.629 167.283 208.764 165.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.705 173.532C210.357 173.386 210.903 172.848 211.189 171.952C211.761 170.159 211.078 167.611 209.663 166.263C208.955 165.588 208.198 165.341 207.547 165.487C207.152 165.575 207.084 165.591 206.688 165.679C206.037 165.824 205.491 166.363 205.204 167.259C204.632 169.052 205.315 171.599 206.73 172.948C207.438 173.622 208.195 173.869 208.846 173.724C209.241 173.636 209.31 173.62 209.705 173.532Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M209.705 173.532C210.357 173.386 210.903 172.848 211.189 171.952C211.761 170.159 211.078 167.611 209.663 166.263C208.955 165.588 208.198 165.341 207.547 165.487C207.152 165.575 207.084 165.591 206.688 165.679C206.037 165.824 205.491 166.363 205.204 167.259C204.632 169.052 205.315 171.599 206.73 172.948C207.438 173.622 208.195 173.869 208.846 173.724C209.241 173.636 209.31 173.62 209.705 173.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.189 171.952C211.308 171.58 211.369 171.176 211.385 170.757L205.952 171.971C206.178 172.336 206.438 172.668 206.731 172.948C207.438 173.622 208.195 173.869 208.846 173.724C209.241 173.636 209.31 173.62 209.705 173.532C210.357 173.386 210.903 172.848 211.189 171.952Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.663 166.263C208.955 165.588 208.198 165.341 207.548 165.487C206.896 165.632 206.351 166.17 206.064 167.067C205.491 168.86 206.174 171.407 207.59 172.755C208.298 173.43 209.054 173.677 209.705 173.532C210.357 173.386 210.903 172.848 211.189 171.952C211.761 170.159 211.078 167.612 209.663 166.263Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M209.663 166.263C208.955 165.588 208.198 165.341 207.548 165.487C206.896 165.632 206.351 166.17 206.064 167.067C205.491 168.86 206.174 171.407 207.59 172.755C208.298 173.43 209.054 173.677 209.705 173.532C210.357 173.386 210.903 172.848 211.189 171.952C211.761 170.159 211.078 167.612 209.663 166.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.826 167.231L208.426 168.767C208.306 168.794 208.206 168.893 208.152 169.059C208.047 169.39 208.173 169.86 208.434 170.11C208.565 170.235 208.705 170.28 208.825 170.253L218.826 167.231Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.407 168.775C208.296 168.808 208.202 168.902 208.152 169.059C208.047 169.39 208.173 169.86 208.434 170.11C208.565 170.235 208.705 170.28 208.825 170.253L218.826 167.232C218.826 167.232 210.726 169.206 209.487 169.529C208.529 169.779 208.218 169.235 208.407 168.775Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.185 168.661C217.449 168.826 216.708 168.415 216.528 167.744C216.348 167.073 216.798 166.396 217.533 166.232C218.269 166.068 219.01 166.478 219.19 167.149C219.369 167.82 218.919 168.497 218.185 168.661Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M217.943 166.51C217.916 166.543 217.911 166.586 217.916 166.626C217.936 166.808 218.133 166.921 218.261 167.062C218.348 167.159 218.406 167.276 218.445 167.396C218.467 167.464 218.485 167.534 218.526 167.594C218.604 167.708 218.757 167.767 218.876 167.657C218.937 167.602 218.963 167.523 218.971 167.445C218.983 167.327 218.958 167.21 218.922 167.096C218.899 167.019 218.869 166.944 218.821 166.878C218.699 166.713 218.587 166.598 218.386 166.51C218.261 166.454 218.048 166.383 217.943 166.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.528 167.744C216.708 168.415 217.449 168.826 218.185 168.661C218.496 168.592 218.754 168.43 218.937 168.218C218.847 168.241 218.756 168.26 218.662 168.272C218.299 168.315 217.905 168.239 217.636 168.011C217.383 167.795 217.27 167.469 217.261 167.152C217.251 166.814 217.359 166.462 217.614 166.218C217.587 166.222 217.56 166.226 217.533 166.232C216.798 166.397 216.348 167.073 216.528 167.744Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.935 157.227C214.487 154.894 211.871 154.041 209.618 154.543C201.202 156.424 196.048 164.173 198.108 171.857C200.169 179.537 208.664 184.239 217.081 182.361C219.334 181.856 221.219 179.997 222.209 176.896C224.189 170.698 221.828 161.892 216.935 157.227ZM209.979 179.262C205.308 174.751 203.029 166.254 204.89 160.284C206.751 154.314 212.045 153.132 216.719 157.642C221.392 162.154 223.669 170.65 221.808 176.62C219.947 182.59 214.652 183.774 209.979 179.262Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M216.935 157.227C214.487 154.894 211.871 154.041 209.618 154.543C201.202 156.424 196.048 164.173 198.108 171.857C200.169 179.537 208.664 184.239 217.081 182.361C219.334 181.856 221.219 179.997 222.209 176.896C224.189 170.698 221.828 161.892 216.935 157.227ZM209.979 179.262C205.308 174.751 203.029 166.254 204.89 160.284C206.751 154.314 212.045 153.132 216.719 157.642C221.392 162.154 223.669 170.65 221.808 176.62C219.947 182.59 214.652 183.774 209.979 179.262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M219.912 180.809C219.082 181.606 218.119 182.128 217.082 182.361C208.664 184.239 200.169 179.537 198.108 171.857C197.25 168.659 197.643 165.453 198.998 162.662C198.399 165.254 198.511 167.986 199.519 170.464C200.788 173.583 203.547 176.235 207.011 177.271C207.507 177.42 208.008 177.534 208.515 177.62C208.971 178.211 209.462 178.761 209.979 179.261C213.425 182.589 217.212 182.818 219.705 180.314C219.783 180.476 219.852 180.64 219.912 180.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.934 157.227C212.038 152.563 206.468 153.808 204.488 160.008C202.509 166.206 204.87 175.011 209.765 179.677C214.658 184.34 220.229 183.096 222.209 176.896C224.188 170.698 221.827 161.892 216.934 157.227ZM209.979 179.262C205.308 174.751 203.029 166.254 204.89 160.284C206.75 154.314 212.045 153.132 216.718 157.642C221.391 162.154 223.668 170.65 221.807 176.62C219.947 182.59 214.652 183.774 209.979 179.262Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M216.934 157.227C212.038 152.563 206.468 153.808 204.488 160.008C202.509 166.206 204.87 175.011 209.765 179.677C214.658 184.34 220.229 183.096 222.209 176.896C224.188 170.698 221.827 161.892 216.934 157.227ZM209.979 179.262C205.308 174.751 203.029 166.254 204.89 160.284C206.75 154.314 212.045 153.132 216.718 157.642C221.391 162.154 223.668 170.65 221.807 176.62C219.947 182.59 214.652 183.774 209.979 179.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.746 164.326C202.223 164.696 201.713 165.076 201.208 165.44C201.017 165.577 200.827 165.716 200.639 165.857C201.11 168.304 202.383 171.385 204.285 173.086C203.181 170.272 202.627 167.194 202.746 164.326ZM204.209 158.432C202.964 159.056 201.294 160.96 200.605 162.763C200.42 163.246 200.39 164.023 200.498 164.951C200.618 164.865 200.739 164.779 200.86 164.695C201.507 164.245 202.147 163.789 202.81 163.376C202.913 162.306 203.116 161.274 203.424 160.306C203.643 159.62 203.907 158.995 204.209 158.432Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M202.746 164.326C202.223 164.696 201.713 165.076 201.208 165.44C201.017 165.577 200.827 165.716 200.639 165.857C201.11 168.304 202.383 171.385 204.285 173.086C203.181 170.272 202.627 167.194 202.746 164.326ZM204.209 158.432C202.964 159.056 201.294 160.96 200.605 162.763C200.42 163.246 200.39 164.023 200.498 164.951C200.618 164.865 200.739 164.779 200.86 164.695C201.507 164.245 202.147 163.789 202.81 163.376C202.913 162.306 203.116 161.274 203.424 160.306C203.643 159.62 203.907 158.995 204.209 158.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.578 34.917L170.749 135.759C170.749 136.062 170.969 136.366 171.408 136.597C172.287 137.061 173.712 137.061 174.591 136.597C175.03 136.366 175.25 136.062 175.25 135.759L173.42 34.917H172.578Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.094 34.917C173.239 69.664 173.509 131.458 173.605 133.721C173.709 136.163 171.956 136.556 170.759 135.811C170.783 136.097 170.994 136.38 171.409 136.598C172.287 137.061 173.713 137.061 174.591 136.598C175.03 136.366 175.25 136.063 175.25 135.76L173.42 34.9177L173.094 34.917Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.679 34.1174C176.679 35.972 175.032 37.4748 173 37.4748C170.967 37.4748 169.32 35.972 169.32 34.1174C169.32 32.2636 170.967 30.76 173 30.76C175.032 30.76 176.679 32.2636 176.679 34.1174Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.378 33.3186C170.455 33.4021 170.574 33.4443 170.692 33.459C171.225 33.5257 171.673 33.1284 172.158 32.9157C172.49 32.7697 172.86 32.7079 173.228 32.6911C173.436 32.6812 173.649 32.6848 173.847 32.6251C174.221 32.5114 174.488 32.185 174.252 31.8312C174.133 31.6522 173.922 31.5385 173.705 31.4704C173.378 31.3672 173.024 31.3511 172.678 31.363C172.444 31.3707 172.208 31.3911 171.988 31.4655C171.439 31.6515 171.041 31.8431 170.66 32.2643C170.42 32.5275 170.08 32.9887 170.378 33.3186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173 37.4749C175.031 37.4749 176.679 35.9721 176.679 34.1175C176.679 33.3342 176.383 32.6161 175.89 32.0447C176.226 33.1888 176.037 35.0743 174.46 35.8738C172.883 36.6733 169.78 36.0612 169.332 33.9161C169.327 33.9827 169.32 34.0494 169.32 34.1175C169.32 35.9721 170.968 37.4749 173 37.4749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.494 126.392C148.296 126.497 148.173 126.72 148.173 127.039C148.173 127.676 148.663 128.45 149.267 128.769C149.57 128.928 149.844 128.943 150.041 128.839C150.161 128.776 172.721 116.89 172.841 116.827C173.039 116.722 173.162 116.498 173.162 116.18C173.162 115.543 172.672 114.769 172.068 114.45C171.765 114.291 171.491 114.276 171.294 114.38C171.174 114.444 148.614 126.329 148.494 126.392Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.267 128.77C149.57 128.929 149.844 128.944 150.041 128.84C150.24 128.735 150.362 128.512 150.362 128.194C150.362 127.556 149.872 126.782 149.267 126.463C148.965 126.304 148.691 126.289 148.494 126.393C148.296 126.498 148.173 126.722 148.173 127.04C148.173 127.676 148.663 128.451 149.267 128.77Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.725 89.6904C149.589 89.7627 149.504 89.9172 149.504 90.1369C149.504 90.577 149.842 91.1119 150.26 91.3323C150.469 91.4425 150.658 91.453 150.795 91.3807C150.878 91.3372 172.955 79.6702 173.038 79.6266C173.175 79.5543 173.259 79.3999 173.259 79.1802C173.259 78.7401 172.921 78.2052 172.503 77.9848C172.295 77.8746 172.106 77.8647 171.969 77.9363C171.886 77.9799 149.809 89.6469 149.725 89.6904Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26 91.3324C150.469 91.4426 150.658 91.4524 150.795 91.3808C150.932 91.3085 151.016 91.1541 151.016 90.9344C151.016 90.4943 150.678 89.9594 150.26 89.739C150.052 89.6288 149.862 89.6182 149.725 89.6905C149.589 89.7628 149.504 89.9173 149.504 90.137C149.504 90.5778 149.842 91.1127 150.26 91.3324Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.494 137.341C148.296 137.446 148.173 137.669 148.173 137.988C148.173 138.625 148.663 139.399 149.267 139.718C149.57 139.877 149.844 139.892 150.041 139.788C150.161 139.725 172.721 127.839 172.841 127.776C173.039 127.671 173.162 127.447 173.162 127.129C173.162 126.492 172.672 125.718 172.068 125.399C171.765 125.24 171.491 125.225 171.294 125.329C171.174 125.393 148.614 137.278 148.494 137.341Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.267 139.719C149.57 139.878 149.844 139.893 150.041 139.789C150.24 139.684 150.362 139.461 150.362 139.143C150.362 138.505 149.872 137.731 149.267 137.412C148.965 137.253 148.691 137.238 148.494 137.342C148.296 137.447 148.173 137.671 148.173 137.989C148.173 138.625 148.663 139.4 149.267 139.719Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.181 102.626C137.181 101.944 137.443 101.465 137.867 101.242C138.291 101.019 141.648 99.2462 142.076 99.0244C142.5 98.8047 143.083 98.8384 143.727 99.1774L161.022 108.289C162.316 108.971 163.365 110.63 163.365 111.993V162.492C163.365 163.173 163.103 163.653 162.679 163.876C162.255 164.099 158.901 165.866 158.476 166.09C158.052 166.313 157.466 166.281 156.819 165.94L139.524 156.828C138.23 156.147 137.181 154.488 137.181 153.125V102.626Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M137.181 102.626C137.181 101.944 137.443 101.465 137.867 101.242C138.291 101.019 141.648 99.2462 142.076 99.0244C142.5 98.8047 143.083 98.8384 143.727 99.1774L161.022 108.289C162.316 108.971 163.365 110.63 163.365 111.993V162.492C163.365 163.173 163.103 163.653 162.679 163.876C162.255 164.099 158.901 165.866 158.476 166.09C158.052 166.313 157.466 166.281 156.819 165.94L139.524 156.828C138.23 156.147 137.181 154.488 137.181 153.125V102.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.165 114.207V164.703C159.165 165.353 158.931 165.822 158.534 166.061C159.301 165.658 162.264 164.094 162.679 163.88C163.103 163.65 163.365 163.172 163.365 162.489V111.993C163.365 111.327 163.112 110.594 162.706 109.936C160.081 111.319 160.681 110.997 158.507 112.15C158.913 112.8 159.165 113.541 159.165 114.207Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.165 114.207V164.703C159.165 165.353 158.931 165.822 158.534 166.061C159.301 165.658 162.264 164.094 162.679 163.88C163.103 163.65 163.365 163.172 163.365 162.489V111.993C163.365 111.327 163.112 110.594 162.706 109.936C160.081 111.319 160.681 110.997 158.507 112.15C158.913 112.8 159.165 113.541 159.165 114.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.819 110.504L139.524 101.392C138.877 101.051 138.291 101.018 137.867 101.242C137.443 101.465 137.181 101.945 137.181 102.627V153.125C137.181 154.489 138.23 156.147 139.524 156.829L156.819 165.941C157.466 166.282 158.052 166.314 158.476 166.09C158.9 165.867 159.162 165.387 159.162 164.706V114.207C159.163 112.843 158.114 111.185 156.819 110.504Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M156.819 110.504L139.524 101.392C138.877 101.051 138.291 101.018 137.867 101.242C137.443 101.465 137.181 101.945 137.181 102.627V153.125C137.181 154.489 138.23 156.147 139.524 156.829L156.819 165.941C157.466 166.282 158.052 166.314 158.476 166.09C158.9 165.867 159.162 165.387 159.162 164.706V114.207C159.163 112.843 158.114 111.185 156.819 110.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.243 154.997L139.452 154.053C139.382 154.016 139.324 153.917 139.324 153.832V151.267C139.324 151.182 139.381 151.142 139.452 151.18L141.243 152.123C141.313 152.16 141.37 152.259 141.37 152.345V154.909C141.37 154.995 141.313 155.034 141.243 154.997Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.555 156.743L142.765 155.799C142.695 155.762 142.638 155.663 142.638 155.577V153.013C142.638 152.928 142.695 152.888 142.765 152.925L144.555 153.869C144.625 153.906 144.682 154.005 144.682 154.091V156.655C144.682 156.74 144.625 156.78 144.555 156.743Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.869 158.488L146.078 157.544C146.008 157.507 145.951 157.408 145.951 157.322V154.758C145.951 154.673 146.008 154.633 146.078 154.671L147.869 155.614C147.939 155.651 147.996 155.75 147.996 155.836V158.4C147.996 158.486 147.939 158.525 147.869 158.488Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.212 162.337L149.319 158.178V159.252L157.212 163.411V162.337Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.226 107.45C197.425 107.555 197.547 107.778 197.547 108.097C197.547 108.734 197.057 109.509 196.452 109.827C196.15 109.987 195.876 110.001 195.678 109.897C195.558 109.834 172.998 97.9482 172.878 97.885C172.681 97.7804 172.558 97.5565 172.558 97.2385C172.558 96.6011 173.048 95.8269 173.652 95.5082C173.955 95.3489 174.228 95.3341 174.426 95.438C174.546 95.5012 197.106 107.387 197.226 107.45Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.453 109.827C196.151 109.987 195.877 110.001 195.679 109.897C195.481 109.793 195.358 109.569 195.358 109.251C195.358 108.614 195.848 107.839 196.453 107.521C196.755 107.361 197.029 107.347 197.227 107.45C197.425 107.555 197.548 107.778 197.548 108.097C197.548 108.734 197.058 109.509 196.453 109.827Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.226 118.399C197.425 118.504 197.547 118.727 197.547 119.046C197.547 119.683 197.057 120.457 196.452 120.776C196.15 120.936 195.876 120.95 195.678 120.846C195.558 120.783 172.998 108.897 172.878 108.834C172.681 108.729 172.558 108.505 172.558 108.187C172.558 107.55 173.048 106.776 173.652 106.457C173.955 106.298 174.228 106.283 174.426 106.387C174.546 106.451 197.106 118.336 197.226 118.399Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.453 120.776C196.151 120.935 195.877 120.95 195.679 120.846C195.481 120.742 195.358 120.518 195.358 120.2C195.358 119.562 195.848 118.788 196.453 118.469C196.755 118.31 197.029 118.295 197.227 118.399C197.425 118.504 197.548 118.728 197.548 119.046C197.548 119.683 197.058 120.458 196.453 120.776Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.807 91.3111C208.807 90.6295 208.544 90.1501 208.121 89.9269C207.697 89.7037 204.339 87.9313 203.911 87.7095C203.488 87.4897 202.904 87.5234 202.261 87.8625L184.965 96.9744C183.671 97.656 182.622 99.3147 182.622 100.678V151.177C182.622 151.858 182.884 152.338 183.308 152.561C183.732 152.784 187.087 154.552 187.511 154.775C187.935 154.998 188.521 154.966 189.168 154.625L206.464 145.513C207.758 144.831 208.807 143.172 208.807 141.809V91.3111Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M208.807 91.3111C208.807 90.6295 208.544 90.1501 208.121 89.9269C207.697 89.7037 204.339 87.9313 203.911 87.7095C203.488 87.4897 202.904 87.5234 202.261 87.8625L184.965 96.9744C183.671 97.656 182.622 99.3147 182.622 100.678V151.177C182.622 151.858 182.884 152.338 183.308 152.561C183.732 152.784 187.087 154.552 187.511 154.775C187.935 154.998 188.521 154.966 189.168 154.625L206.464 145.513C207.758 144.831 208.807 143.172 208.807 141.809V91.3111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.822 102.893V153.388C186.822 154.038 187.056 154.507 187.453 154.746C186.686 154.343 183.723 152.779 183.308 152.565C182.885 152.335 182.623 151.858 182.623 151.174V100.679C182.623 100.012 182.875 99.2798 183.282 98.6213C185.906 100.004 185.307 99.6827 187.481 100.835C187.074 101.485 186.822 102.226 186.822 102.893Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M186.822 102.893V153.388C186.822 154.038 187.056 154.507 187.453 154.746C186.686 154.343 183.723 152.779 183.308 152.565C182.885 152.335 182.623 151.858 182.623 151.174V100.679C182.623 100.012 182.875 99.2798 183.282 98.6213C185.906 100.004 185.307 99.6827 187.481 100.835C187.074 101.485 186.822 102.226 186.822 102.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.168 99.189L206.464 90.0771C207.111 89.7359 207.697 89.7036 208.121 89.9276C208.545 90.1508 208.807 90.6302 208.807 91.3118V141.81C208.807 143.174 207.758 144.832 206.464 145.514L189.168 154.626C188.521 154.967 187.935 154.999 187.511 154.775C187.088 154.552 186.825 154.073 186.825 153.391V102.893C186.825 101.529 187.874 99.8706 189.168 99.189Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M189.168 99.189L206.464 90.0771C207.111 89.7359 207.697 89.7036 208.121 89.9276C208.545 90.1508 208.807 90.6302 208.807 91.3118V141.81C208.807 143.174 207.758 144.832 206.464 145.514L189.168 154.626C188.521 154.967 187.935 154.999 187.511 154.775C187.088 154.552 186.825 154.073 186.825 153.391V102.893C186.825 101.529 187.874 99.8706 189.168 99.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.093 150.228L189.303 151.172C189.233 151.209 189.176 151.17 189.176 151.084V148.52C189.176 148.434 189.233 148.335 189.303 148.298L191.093 147.355C191.164 147.317 191.221 147.357 191.221 147.442V150.007C191.22 150.092 191.163 150.191 191.093 150.228Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.407 148.483L192.616 149.427C192.546 149.464 192.489 149.425 192.489 149.339V146.775C192.489 146.689 192.546 146.589 192.616 146.553L194.407 145.609C194.477 145.572 194.535 145.612 194.535 145.697V148.261C194.534 148.346 194.477 148.446 194.407 148.483Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.72 146.738L195.929 147.681C195.859 147.718 195.802 147.679 195.802 147.593V145.029C195.802 144.943 195.859 144.844 195.929 144.807L197.72 143.864C197.791 143.827 197.848 143.866 197.848 143.952V146.516C197.847 146.601 197.79 146.7 197.72 146.738Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.063 140.74L199.17 144.899V145.973L207.063 141.815V140.74Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.325 83.7001C143.282 77.7307 147.824 75.3378 153.468 78.3562C159.113 81.3745 163.722 88.66 163.765 94.6301C163.807 100.599 159.265 102.992 153.621 99.974C147.976 96.9556 143.367 89.6694 143.325 83.7001Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M148.2 95.4437C148.313 95.5139 148.424 95.5841 148.539 95.6515C150.974 97.0806 154.052 97.77 156.824 97.0076C159.176 96.3604 161.103 94.7284 162.357 92.8002C162.706 92.2632 163.007 91.703 163.269 91.1274C163.582 92.3172 163.755 93.4972 163.763 94.6308C163.806 100.6 159.264 102.993 153.619 99.9748C151.634 98.9113 149.776 97.3193 148.2 95.4437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.525 91.0234C160.789 91.4108 159.772 91.3554 158.649 90.7637C156.403 89.5802 154.582 86.7022 154.582 84.3352C154.582 83.1518 155.037 82.32 155.774 81.9325C156.22 81.6973 156.297 81.6559 156.744 81.4208C157.481 81.0333 158.497 81.0894 159.621 81.6805C161.867 82.864 163.687 85.7419 163.687 88.1089C163.687 89.2924 163.232 90.1235 162.496 90.5117C162.049 90.7475 161.972 90.7882 161.525 91.0234Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.525 91.0234C160.789 91.4108 159.772 91.3554 158.649 90.7637C156.403 89.5802 154.582 86.7022 154.582 84.3352C154.582 83.1518 155.037 82.32 155.774 81.9325C156.22 81.6973 156.297 81.6559 156.744 81.4208C157.481 81.0333 158.497 81.0894 159.621 81.6805C161.867 82.864 163.687 85.7419 163.687 88.1089C163.687 89.2924 163.232 90.1235 162.496 90.5117C162.049 90.7475 161.972 90.7882 161.525 91.0234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.648 90.7637C157.863 90.3502 157.132 89.7269 156.511 88.9927L163.075 85.5342C163.46 86.392 163.686 87.2813 163.686 88.1089C163.686 89.2924 163.231 90.1235 162.495 90.5117C162.048 90.7475 161.97 90.7882 161.523 91.0234C160.788 91.4109 159.772 91.3554 158.648 90.7637Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.582 84.3352C154.582 83.1517 155.037 82.3206 155.774 81.9325C156.51 81.545 157.527 81.6004 158.65 82.1922C160.896 83.3756 162.717 86.2536 162.717 88.6206C162.717 89.8041 162.261 90.6352 161.525 91.0233C160.789 91.4108 159.772 91.3547 158.649 90.7629C156.403 89.5802 154.582 86.7015 154.582 84.3352Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M154.582 84.3352C154.582 83.1517 155.037 82.3206 155.774 81.9325C156.51 81.545 157.527 81.6004 158.65 82.1922C160.896 83.3756 162.717 86.2536 162.717 88.6206C162.717 89.8041 162.261 90.6352 161.525 91.0233C160.789 91.4108 159.772 91.3547 158.649 90.7629C156.403 89.5802 154.582 86.7015 154.582 84.3352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.779 90.4817C159.221 90.7758 158.449 90.7337 157.597 90.2844C155.892 89.3866 154.511 87.2022 154.511 85.4066C154.511 84.5081 154.856 83.8778 155.415 83.5829C155.754 83.4039 155.812 83.3737 156.152 83.1948C156.71 82.9006 157.482 82.9435 158.334 83.392C160.038 84.2905 161.42 86.4742 161.42 88.2705C161.42 89.1683 161.075 89.7994 160.516 90.0935C160.177 90.2725 160.118 90.3034 159.779 90.4817Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.779 90.4817C159.221 90.7758 158.449 90.7337 157.597 90.2844C155.892 89.3866 154.511 87.2022 154.511 85.4066C154.511 84.5081 154.856 83.8778 155.415 83.5829C155.754 83.4039 155.812 83.3737 156.152 83.1948C156.71 82.9006 157.482 82.9435 158.334 83.392C160.038 84.2905 161.42 86.4742 161.42 88.2705C161.42 89.1683 161.075 89.7994 160.516 90.0935C160.177 90.2725 160.118 90.3034 159.779 90.4817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M157.597 90.2849C157.244 90.0989 156.906 89.8553 156.59 89.5739L161.248 87.1191C161.358 87.5094 161.42 87.8983 161.42 88.2703C161.42 89.1681 161.074 89.7992 160.516 90.0933C160.177 90.2723 160.118 90.3032 159.779 90.4815C159.221 90.7763 158.449 90.7335 157.597 90.2849Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.51 85.4063C154.51 84.5086 154.855 83.8775 155.414 83.5834C155.972 83.2893 156.744 83.3314 157.596 83.7806C159.301 84.6784 160.682 86.8629 160.682 88.6585C160.682 89.5563 160.337 90.1873 159.778 90.4814C159.22 90.7755 158.448 90.7334 157.596 90.2842C155.892 89.3864 154.51 87.2026 154.51 85.4063Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M154.51 85.4063C154.51 84.5086 154.855 83.8775 155.414 83.5834C155.972 83.2893 156.744 83.3314 157.596 83.7806C159.301 84.6784 160.682 86.8629 160.682 88.6585C160.682 89.5563 160.337 90.1873 159.778 90.4814C159.22 90.7755 158.448 90.7334 157.596 90.2842C155.892 89.3864 154.51 87.2026 154.51 85.4063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.85 91.6405L157.193 86.3955C157.297 86.3415 157.439 86.3492 157.597 86.432C157.911 86.5977 158.167 87.0013 158.167 87.3326C158.167 87.4983 158.103 87.6148 158 87.6695L148.85 91.6405Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.213 86.389C157.314 86.3448 157.448 86.3539 157.597 86.4318C157.911 86.5975 158.167 87.0011 158.167 87.3324C158.167 87.4981 158.103 87.6146 158 87.6694L148.85 91.6403C148.85 91.6403 155.916 88.0955 157.012 87.5683C157.86 87.1605 157.68 86.594 157.213 86.389Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.337 92.2453C150.967 91.9133 151.183 91.1776 150.82 90.6027C150.456 90.0271 149.65 89.8306 149.02 90.1626C148.389 90.4946 148.173 91.2303 148.537 91.8052C148.901 92.3801 149.706 92.5773 150.337 92.2453Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.937 90.6048C148.979 90.6112 149.015 90.6378 149.041 90.6687C149.159 90.8077 149.104 91.0056 149.118 91.1811C149.128 91.3012 149.174 91.417 149.234 91.5244C149.268 91.5848 149.307 91.6444 149.322 91.7118C149.351 91.8382 149.288 91.9722 149.125 91.9687C149.042 91.9673 148.966 91.928 148.904 91.8789C148.81 91.8045 148.742 91.7076 148.683 91.6072C148.644 91.5398 148.608 91.4689 148.595 91.3938C148.559 91.205 148.553 91.0576 148.628 90.8744C148.675 90.7579 148.771 90.5789 148.937 90.6048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82 90.6021C151.184 91.177 150.968 91.9126 150.338 92.2446C150.071 92.385 149.774 92.4299 149.491 92.3927C149.571 92.3548 149.648 92.312 149.721 92.2629C150.005 92.0726 150.224 91.7813 150.244 91.4598C150.262 91.1559 150.102 90.8604 149.878 90.6351C149.639 90.3936 149.307 90.2153 148.952 90.2005C148.974 90.1872 148.995 90.1739 149.018 90.1612C149.65 89.8299 150.456 90.0272 150.82 90.6021Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.543 100.409C156.492 101.962 159.156 102.11 161.089 101.093C168.306 97.2892 170.779 88.8665 166.614 82.2802C162.443 75.6917 153.215 73.4378 145.997 77.2388C144.066 78.2566 142.87 80.4369 142.871 83.5437C142.873 89.7538 147.651 97.3039 153.543 100.409ZM153.621 99.9734C147.977 96.955 143.366 89.6709 143.323 83.7002C143.283 77.7301 147.822 75.3379 153.467 78.3563C159.111 81.3746 163.72 88.6608 163.764 94.6295C163.807 100.6 159.266 102.992 153.621 99.9734Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M153.543 100.409C156.492 101.962 159.156 102.11 161.089 101.093C168.306 97.2892 170.779 88.8665 166.614 82.2802C162.443 75.6917 153.215 73.4378 145.997 77.2388C144.066 78.2566 142.87 80.4369 142.871 83.5437C142.873 89.7538 147.651 97.3039 153.543 100.409ZM153.621 99.9734C147.977 96.955 143.366 89.6709 143.323 83.7002C143.283 77.7301 147.822 75.3379 153.467 78.3563C159.111 81.3746 163.72 88.6608 163.764 94.6295C163.807 100.6 159.266 102.992 153.621 99.9734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.992 101.733C159.149 101.783 160.198 101.561 161.089 101.093C168.306 97.289 170.779 88.8664 166.614 82.28C164.88 79.5382 162.27 77.5489 159.294 76.4321C161.599 77.869 163.514 79.8345 164.619 82.1684C166.011 85.1047 166.028 88.6214 164.376 91.4453C164.14 91.849 163.875 92.2322 163.586 92.6007C163.701 93.2872 163.759 93.9674 163.765 94.6294C163.797 99.0327 161.334 101.489 157.775 101.263C157.839 101.423 157.911 101.579 157.992 101.733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.544 100.409C159.438 103.514 164.215 100.998 164.216 94.7881C164.215 88.5752 159.438 81.025 153.545 77.921C147.651 74.8156 142.874 77.3314 142.872 83.5429C142.874 89.7537 147.651 97.3039 153.544 100.409ZM153.621 99.9733C147.977 96.955 143.367 89.6709 143.324 83.7001C143.283 77.7301 147.822 75.3379 153.467 78.3562C159.111 81.3746 163.721 88.6608 163.764 94.6294C163.807 100.6 159.266 102.992 153.621 99.9733Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.544 100.409C159.438 103.514 164.215 100.998 164.216 94.7881C164.215 88.5752 159.438 81.025 153.545 77.921C147.651 74.8156 142.874 77.3314 142.872 83.5429C142.874 89.7537 147.651 97.3039 153.544 100.409ZM153.621 99.9733C147.977 96.955 143.367 89.6709 143.324 83.7001C143.283 77.7301 147.822 75.3379 153.467 78.3562C159.111 81.3746 163.721 88.6608 163.764 94.6294C163.807 100.6 159.266 102.992 153.621 99.9733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.219 86.8827C163.301 84.5467 161.939 81.6329 160.482 79.6471C160.249 79.6639 160.015 79.6829 159.783 79.7032C159.168 79.7573 158.535 79.8022 157.902 79.8626C160.075 81.7831 161.934 84.2582 163.219 86.8827ZM154.501 77.4823C155.421 77.9673 156.314 78.5619 157.165 79.242C157.929 79.1269 158.705 79.0539 159.482 78.9746C159.628 78.9599 159.775 78.9458 159.921 78.9325C159.319 78.2221 158.732 77.7006 158.252 77.4774C156.459 76.6434 153.91 76.3339 152.591 76.6561C153.21 76.8646 153.849 77.139 154.501 77.4823Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.219 86.8827C163.301 84.5467 161.939 81.6329 160.482 79.6471C160.249 79.6639 160.015 79.6829 159.783 79.7032C159.168 79.7573 158.535 79.8022 157.902 79.8626C160.075 81.7831 161.934 84.2582 163.219 86.8827ZM154.501 77.4823C155.421 77.9673 156.314 78.5619 157.165 79.242C157.929 79.1269 158.705 79.0539 159.482 78.9746C159.628 78.9599 159.775 78.9458 159.921 78.9325C159.319 78.2221 158.732 77.7006 158.252 77.4774C156.459 76.6434 153.91 76.3339 152.591 76.6561C153.21 76.8646 153.849 77.139 154.501 77.4823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.917 26.7891C160.88 26.8347 160.846 26.8817 160.816 26.9294C160.39 27.6019 160.589 28.4555 161.278 28.9145C161.637 29.1546 162.078 29.2522 162.518 29.1904C162.959 29.1286 163.346 28.9131 163.609 28.5853C165.792 25.8618 169.301 24.2354 172.996 24.2354C176.69 24.2347 180.199 25.8604 182.384 28.5853C182.647 28.9138 183.034 29.1279 183.474 29.1911C183.914 29.2529 184.354 29.156 184.713 28.9159C184.902 28.7896 185.057 28.6331 185.173 28.4506C185.32 28.2189 185.397 27.9543 185.397 27.684C185.397 27.3618 185.285 27.0516 185.074 26.7891C182.264 23.2849 177.75 21.1931 172.997 21.1931C168.242 21.1924 163.727 23.2842 160.917 26.7891ZM153.627 18.4949C153.542 18.5791 153.467 18.6718 153.406 18.77C153.021 19.3779 153.153 20.1669 153.719 20.6456C154.046 20.9215 154.471 21.0654 154.916 21.0492C155.361 21.0338 155.773 20.8604 156.076 20.5621C160.425 16.2718 166.593 13.8101 172.997 13.8101C179.4 13.8101 185.567 16.2718 189.917 20.5621C190.22 20.8604 190.631 21.0338 191.076 21.0492C191.521 21.0654 191.946 20.9215 192.273 20.6456C192.397 20.541 192.502 20.4203 192.585 20.289C192.73 20.0595 192.807 19.7963 192.808 19.5281C192.808 19.1435 192.65 18.777 192.364 18.4956C187.384 13.584 180.324 10.7671 172.996 10.7678C165.667 10.7671 158.606 13.5833 153.627 18.4949ZM172.995 0C162.853 0 153.301 3.59045 146.102 10.1087C145.995 10.2056 145.904 10.3137 145.83 10.4302C145.456 11.0219 145.563 11.7751 146.093 12.2616C146.406 12.5494 146.825 12.7094 147.27 12.7108C147.716 12.7122 148.135 12.5557 148.451 12.2693C155.022 6.31962 163.739 3.04293 172.997 3.04223C182.254 3.04293 190.97 6.31962 197.542 12.2693C197.857 12.555 198.277 12.7122 198.723 12.7101C199.168 12.7087 199.586 12.5494 199.901 12.2602C200.003 12.1661 200.091 12.0615 200.162 11.9485C200.307 11.7197 200.384 11.4572 200.383 11.189C200.383 10.7805 200.208 10.3965 199.89 10.1094C192.69 3.59045 183.139 0 172.995 0Z",
    fill: "#E69724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.78 216.857C155.78 216.634 155.942 216.411 156.265 216.241C156.911 215.9 157.958 215.9 158.604 216.241C158.927 216.411 159.089 216.634 159.089 216.857C159.089 216.992 159.089 286.433 159.089 286.569C159.089 286.792 158.927 287.014 158.604 287.185C157.958 287.525 156.911 287.525 156.265 287.185C155.942 287.015 155.78 286.792 155.78 286.569C155.78 286.433 155.78 216.992 155.78 216.857Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.78 216.857C155.78 216.634 155.942 216.411 156.265 216.241C156.911 215.9 157.958 215.9 158.604 216.241C158.927 216.411 159.089 216.634 159.089 216.857C159.089 216.992 159.089 286.433 159.089 286.569C159.089 286.792 158.927 287.014 158.604 287.185C157.958 287.525 156.911 287.525 156.265 287.185C155.942 287.015 155.78 286.792 155.78 286.569C155.78 286.433 155.78 216.992 155.78 216.857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.604 216.241C158.927 216.411 159.089 216.634 159.089 216.857C159.089 217.08 158.927 217.303 158.604 217.474C157.958 217.814 156.911 217.814 156.265 217.474C155.942 217.304 155.78 217.08 155.78 216.857C155.78 216.634 155.942 216.411 156.265 216.241C156.911 215.901 157.958 215.901 158.604 216.241Z",
    fill: "#E2982C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.497 204.085C131.497 203.861 131.659 203.639 131.982 203.468C132.628 203.128 133.675 203.128 134.321 203.468C134.644 203.638 134.806 203.861 134.806 204.085C134.806 204.22 134.806 273.661 134.806 273.796C134.806 274.019 134.644 274.242 134.321 274.412C133.675 274.753 132.628 274.753 131.982 274.412C131.659 274.243 131.497 274.019 131.497 273.796C131.497 273.661 131.497 204.22 131.497 204.085Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M131.497 204.085C131.497 203.861 131.659 203.639 131.982 203.468C132.628 203.128 133.675 203.128 134.321 203.468C134.644 203.638 134.806 203.861 134.806 204.085C134.806 204.22 134.806 273.661 134.806 273.796C134.806 274.019 134.644 274.242 134.321 274.412C133.675 274.753 132.628 274.753 131.982 274.412C131.659 274.243 131.497 274.019 131.497 273.796C131.497 273.661 131.497 204.22 131.497 204.085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.32 203.468C134.643 203.638 134.805 203.861 134.805 204.085C134.805 204.308 134.643 204.53 134.32 204.701C133.674 205.041 132.627 205.041 131.981 204.701C131.658 204.531 131.496 204.308 131.496 204.085C131.496 203.861 131.658 203.639 131.981 203.468C132.627 203.128 133.675 203.128 134.32 203.468Z",
    fill: "#E2982C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.993 176.04C140.07 175.805 140.379 175.593 140.905 175.459C141.957 175.191 143.474 175.339 144.295 175.789C144.705 176.014 144.863 176.272 144.787 176.507C144.741 176.65 109.395 286.226 109.349 286.368C109.273 286.603 108.964 286.815 108.438 286.949C107.386 287.217 105.869 287.069 105.048 286.619C104.638 286.394 104.479 286.136 104.556 285.901C104.601 285.758 139.947 176.182 139.993 176.04Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M139.993 176.04C140.07 175.805 140.379 175.593 140.905 175.459C141.957 175.191 143.474 175.339 144.295 175.789C144.705 176.014 144.863 176.272 144.787 176.507C144.741 176.65 109.395 286.226 109.349 286.368C109.273 286.603 108.964 286.815 108.438 286.949C107.386 287.217 105.869 287.069 105.048 286.619C104.638 286.394 104.479 286.136 104.556 285.901C104.601 285.758 139.947 176.182 139.993 176.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.296 175.789C144.706 176.014 144.864 176.272 144.788 176.507C144.712 176.742 144.403 176.954 143.876 177.088C142.825 177.356 141.306 177.208 140.486 176.758C140.076 176.533 139.918 176.275 139.994 176.04C140.069 175.805 140.379 175.593 140.906 175.459C141.957 175.192 143.475 175.339 144.296 175.789Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.296 175.789C144.706 176.014 144.864 176.272 144.788 176.507C144.712 176.742 144.403 176.954 143.876 177.088C142.825 177.356 141.306 177.208 140.486 176.758C140.076 176.533 139.918 176.275 139.994 176.04C140.069 175.805 140.379 175.593 140.906 175.459C141.957 175.192 143.475 175.339 144.296 175.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.882 293.206C134.089 293.315 134.358 293.3 134.639 293.134C135.203 292.802 135.601 291.994 135.531 291.33C135.496 290.998 135.349 290.764 135.143 290.655C135.016 290.589 110.772 277.84 110.645 277.774C110.438 277.665 110.169 277.68 109.888 277.846C109.325 278.178 108.926 278.985 108.996 279.65C109.032 279.983 109.177 280.216 109.385 280.324C109.51 280.391 133.756 293.14 133.882 293.206Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M133.882 293.206C134.089 293.315 134.358 293.3 134.639 293.134C135.203 292.802 135.601 291.994 135.531 291.33C135.496 290.998 135.349 290.764 135.143 290.655C135.016 290.589 110.772 277.84 110.645 277.774C110.438 277.665 110.169 277.68 109.888 277.846C109.325 278.178 108.926 278.985 108.996 279.65C109.032 279.983 109.177 280.216 109.385 280.324C109.51 280.391 133.756 293.14 133.882 293.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.531 291.329C135.496 290.997 135.35 290.763 135.143 290.654C134.936 290.544 134.667 290.561 134.385 290.726C133.822 291.058 133.423 291.866 133.493 292.53C133.529 292.862 133.674 293.096 133.882 293.206C134.09 293.314 134.358 293.299 134.64 293.133C135.202 292.802 135.601 291.994 135.531 291.329Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.106 273.987C140.313 274.096 140.582 274.08 140.863 273.915C141.426 273.583 141.825 272.775 141.755 272.111C141.719 271.779 141.573 271.545 141.366 271.436C141.24 271.37 116.995 258.621 116.869 258.555C116.662 258.446 116.393 258.461 116.112 258.627C115.549 258.959 115.149 259.766 115.22 260.431C115.255 260.764 115.401 260.997 115.609 261.106C115.735 261.172 139.979 273.921 140.106 273.987Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M140.106 273.987C140.313 274.096 140.582 274.08 140.863 273.915C141.426 273.583 141.825 272.775 141.755 272.111C141.719 271.779 141.573 271.545 141.366 271.436C141.24 271.37 116.995 258.621 116.869 258.555C116.662 258.446 116.393 258.461 116.112 258.627C115.549 258.959 115.149 259.766 115.22 260.431C115.255 260.764 115.401 260.997 115.609 261.106C115.735 261.172 139.979 273.921 140.106 273.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.755 272.11C141.719 271.778 141.573 271.544 141.366 271.435C141.159 271.327 140.89 271.342 140.609 271.508C140.045 271.84 139.647 272.647 139.717 273.312C139.752 273.644 139.898 273.877 140.105 273.986C140.313 274.095 140.582 274.08 140.863 273.914C141.426 273.583 141.825 272.775 141.755 272.11Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.328 254.768C146.536 254.877 146.804 254.861 147.086 254.695C147.649 254.363 148.048 253.556 147.977 252.891C147.942 252.559 147.797 252.326 147.589 252.216C147.463 252.15 123.218 239.401 123.092 239.335C122.884 239.226 122.616 239.241 122.334 239.407C121.771 239.739 121.373 240.546 121.443 241.211C121.478 241.543 121.623 241.777 121.831 241.886C121.957 241.953 146.203 254.702 146.328 254.768Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M146.328 254.768C146.536 254.877 146.804 254.861 147.086 254.695C147.649 254.363 148.048 253.556 147.977 252.891C147.942 252.559 147.797 252.326 147.589 252.216C147.463 252.15 123.218 239.401 123.092 239.335C122.884 239.226 122.616 239.241 122.334 239.407C121.771 239.739 121.373 240.546 121.443 241.211C121.478 241.543 121.623 241.777 121.831 241.886C121.957 241.953 146.203 254.702 146.328 254.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.977 252.891C147.942 252.559 147.797 252.326 147.589 252.216C147.381 252.107 147.113 252.123 146.831 252.288C146.268 252.62 145.869 253.428 145.94 254.092C145.975 254.424 146.121 254.658 146.328 254.768C146.536 254.877 146.804 254.861 147.086 254.695C147.648 254.363 148.047 253.555 147.977 252.891Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.553 235.549C152.76 235.657 153.029 235.642 153.31 235.476C153.873 235.144 154.273 234.336 154.202 233.672C154.167 233.34 154.021 233.107 153.813 232.998C153.687 232.932 129.443 220.183 129.316 220.116C129.109 220.007 128.84 220.023 128.559 220.189C127.996 220.521 127.597 221.329 127.667 221.993C127.703 222.325 127.849 222.558 128.056 222.667C128.182 222.734 152.426 235.483 152.553 235.549Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.553 235.549C152.76 235.657 153.029 235.642 153.31 235.476C153.873 235.144 154.273 234.336 154.202 233.672C154.167 233.34 154.021 233.107 153.813 232.998C153.687 232.932 129.443 220.183 129.316 220.116C129.109 220.007 128.84 220.023 128.559 220.189C127.996 220.521 127.597 221.329 127.667 221.993C127.703 222.325 127.849 222.558 128.056 222.667C128.182 222.734 152.426 235.483 152.553 235.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.202 233.672C154.167 233.34 154.021 233.106 153.814 232.998C153.606 232.889 153.337 232.904 153.056 233.07C152.493 233.402 152.094 234.209 152.164 234.874C152.2 235.206 152.345 235.44 152.553 235.549C152.761 235.657 153.029 235.642 153.311 235.476C153.874 235.144 154.273 234.336 154.202 233.672Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.775 216.329C158.983 216.438 159.252 216.422 159.533 216.257C160.096 215.925 160.495 215.118 160.425 214.453C160.389 214.121 160.244 213.887 160.036 213.778C159.91 213.712 135.665 200.963 135.539 200.897C135.332 200.788 135.062 200.803 134.782 200.969C134.218 201.301 133.819 202.109 133.89 202.773C133.925 203.105 134.072 203.339 134.278 203.448C134.405 203.514 158.65 216.263 158.775 216.329Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M158.775 216.329C158.983 216.438 159.252 216.422 159.533 216.257C160.096 215.925 160.495 215.118 160.425 214.453C160.389 214.121 160.244 213.887 160.036 213.778C159.91 213.712 135.665 200.963 135.539 200.897C135.332 200.788 135.062 200.803 134.782 200.969C134.218 201.301 133.819 202.109 133.89 202.773C133.925 203.105 134.072 203.339 134.278 203.448C134.405 203.514 158.65 216.263 158.775 216.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.425 214.453C160.389 214.121 160.244 213.887 160.036 213.778C159.829 213.669 159.56 213.685 159.279 213.85C158.715 214.182 158.316 214.99 158.387 215.654C158.422 215.986 158.569 216.22 158.776 216.329C158.983 216.438 159.252 216.422 159.533 216.257C160.096 215.925 160.495 215.117 160.425 214.453Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.998 197.11C165.206 197.219 165.474 197.203 165.756 197.038C166.319 196.706 166.717 195.898 166.647 195.234C166.612 194.902 166.466 194.668 166.259 194.558C166.133 194.492 141.888 181.744 141.762 181.677C141.554 181.568 141.286 181.584 141.004 181.749C140.441 182.081 140.042 182.889 140.113 183.553C140.148 183.885 140.294 184.119 140.501 184.228C140.627 184.295 164.872 197.044 164.998 197.11Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M164.998 197.11C165.206 197.219 165.474 197.203 165.756 197.038C166.319 196.706 166.717 195.898 166.647 195.234C166.612 194.902 166.466 194.668 166.259 194.558C166.133 194.492 141.888 181.744 141.762 181.677C141.554 181.568 141.286 181.584 141.004 181.749C140.441 182.081 140.042 182.889 140.113 183.553C140.148 183.885 140.294 184.119 140.501 184.228C140.627 184.295 164.872 197.044 164.998 197.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.647 195.233C166.612 194.901 166.466 194.668 166.259 194.558C166.051 194.449 165.783 194.465 165.501 194.63C164.938 194.963 164.539 195.77 164.61 196.434C164.645 196.767 164.79 197 164.998 197.11C165.206 197.219 165.474 197.203 165.756 197.037C166.319 196.705 166.718 195.898 166.647 195.233Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.857 152.027C137.785 151.822 137.431 150.978 137.197 150.96C136.999 150.944 136.859 151.056 136.79 151.226C136.691 151.468 136.769 151.703 136.751 152.236C136.599 151.614 136.359 150.72 135.791 150.115C135.705 150.025 135.558 149.913 135.431 149.88C135.313 149.848 134.961 149.807 134.833 149.956C134.833 149.956 134.612 149.597 134.428 149.284C134.277 149.027 133.881 148.469 133.535 148.78C133.259 149.027 133.264 149.497 133.378 150.04C133.2 149.732 133.022 149.506 132.862 149.458C132.384 149.312 132.036 149.52 132.191 150.503C132.347 151.486 132.681 153.459 132.37 155.427C132.319 155.746 132.009 156.786 131.699 156.982C131.273 157.251 131.178 157.072 131.025 156.798C130.72 156.245 130.632 155.482 130.145 155.002C129.555 154.42 128.923 154.328 128.775 154.868C128.761 154.92 128.773 154.975 128.786 155.028C128.97 155.803 129.144 156.573 129.281 157.357C129.458 158.368 129.538 159.41 129.972 160.362C130.335 161.156 130.828 161.938 130.518 163.332C130.027 165.548 126.246 174.074 126.246 174.074C126.246 174.074 122.171 177.194 118.592 179.909C115.403 182.329 112.181 184.845 111.651 191.694L117.758 191.255C117.758 191.255 120.55 189.129 129.926 182.081C132.583 180.084 133.96 179.087 134.542 176.059C135.385 171.672 135.71 168.665 136.333 164.237C136.591 162.409 136.596 162.027 137.251 160.556C137.546 159.896 138.227 157.881 138.329 157.489C138.453 157.013 138.535 156.12 138.544 155.631C138.562 154.599 138.441 153.683 137.857 152.027Z",
    fill: "#FFBDA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.686 194.222C111.111 189.776 111.437 187.544 113.181 184.785C114.926 182.025 120.759 177.854 120.759 177.854C120.759 177.854 122.979 177.931 124.594 180.272C126.209 182.613 126.399 185.418 126.399 185.418L117.062 194.633L110.686 194.222Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.751 152.236C136.799 152.725 136.826 153.201 136.791 153.681C136.78 154.162 136.704 154.641 136.691 155.132C136.865 154.667 136.953 154.181 136.988 153.689C137.001 153.198 136.958 152.693 136.751 152.236Z",
    fill: "#F0997A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.667 160.896C134.573 160.857 134.483 160.808 134.403 160.749C134.248 160.635 134.115 160.487 134.007 160.335C133.789 160.033 133.651 159.678 133.605 159.32C133.505 158.545 133.876 157.67 134.58 157.21C134.6 157.197 134.682 157.203 134.659 157.238C134.229 157.871 133.836 158.522 133.931 159.298C134.01 159.939 134.485 160.488 135.028 160.879C135.079 160.915 135.038 160.965 134.981 160.957C134.864 160.94 134.776 160.942 134.667 160.896Z",
    fill: "#F0997A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.838 154.866C133.892 154.077 133.808 153.259 133.734 152.472C133.663 151.717 133.532 150.964 133.413 150.215C133.412 150.206 133.435 150.204 133.439 150.212C133.735 150.995 133.879 151.794 133.949 152.62C134.013 153.381 133.929 154.109 133.857 154.865C133.855 154.871 133.837 154.873 133.838 154.866Z",
    fill: "#F0997A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.226 155.308C135.28 154.519 135.196 153.701 135.122 152.914C135.094 152.611 135.056 152.31 135.013 152.009C134.971 151.714 134.939 151.412 134.864 151.123C134.841 151.034 134.817 150.945 134.794 150.856C134.764 150.74 134.722 150.633 134.715 150.514C134.707 150.392 134.723 150.269 134.765 150.153C134.769 150.142 134.782 150.129 134.79 150.137C134.764 150.289 134.781 150.445 134.818 150.595C134.843 150.695 134.877 150.793 134.915 150.89C134.949 150.978 134.969 151.062 134.996 151.151C135.079 151.428 135.145 151.708 135.198 151.99C135.264 152.345 135.309 152.703 135.339 153.062C135.403 153.823 135.319 154.551 135.247 155.307C135.245 155.314 135.226 155.315 135.226 155.308Z",
    fill: "#F0997A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.466 188.068C119.436 184.397 119.456 183.777 119.119 182.855C118.656 181.593 116.206 178.792 115.843 175.195C115.481 171.599 120.639 165.943 125.229 166.27C129.819 166.597 132.323 168.85 133.646 171.944C134.451 173.829 133.885 174.107 134.206 175.195C134.837 177.336 135.563 179.966 134.628 182.87C134.149 184.357 133.027 185.094 131.549 185.477C129.966 185.887 128.55 185.854 128.55 185.854C128.55 185.854 128.488 187.703 128.607 188.651C128.759 189.859 129.969 189.863 129.969 189.863C129.969 189.863 119.476 189.206 119.466 188.068Z",
    fill: "#FFBDA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.032 180.628C130.836 181.316 130.067 181.728 129.314 181.549C128.56 181.37 128.109 180.668 128.304 179.981L131.032 180.628Z",
    fill: "#B16668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.001 181.549C129.718 180.911 129.053 180.457 128.271 180.417C128.321 180.943 128.721 181.408 129.314 181.549C129.547 181.605 129.781 181.598 130.001 181.549Z",
    fill: "#F28F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.031 176.222C128.176 176.583 127.985 176.976 127.605 177.102C127.225 177.228 126.8 177.038 126.656 176.679C126.511 176.319 126.702 175.925 127.082 175.799C127.461 175.673 127.887 175.862 128.031 176.222Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.003 174.141L125.499 175.023C125.238 174.628 125.364 174.109 125.78 173.865C126.194 173.622 126.742 173.745 127.003 174.141Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.22 173.937L131.514 173.408C131.657 172.97 132.155 172.732 132.627 172.878C133.098 173.024 133.364 173.498 133.22 173.937Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.259 175.616C133.274 175.968 132.986 176.263 132.615 176.276C132.244 176.288 131.931 176.014 131.915 175.662C131.899 175.311 132.187 175.015 132.558 175.002C132.93 174.989 133.243 175.264 133.259 175.616Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.021 177.927L130.625 179.077L129.557 174.771L133.021 177.927Z",
    fill: "#F0997A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.551 185.854C128.551 185.854 126.606 185.778 125.355 185.226C123.381 184.354 122.708 183.529 122.253 182.454C122.571 183.688 123.244 185.026 125.153 185.845C126.344 186.356 128.536 186.692 128.536 186.692L128.551 185.854Z",
    fill: "#F0997A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.692 173.564C115.825 172.818 116.025 172.091 116.246 171.424C116.389 170.992 116.558 170.56 116.843 170.191C117.128 169.824 117.517 169.536 117.91 169.265C119.192 168.378 120.583 167.607 122.096 167.108C123.608 166.609 125.25 166.389 126.84 166.606C128.527 166.835 130.11 167.552 131.429 168.539C132.527 169.361 133.594 170.107 134.143 171.373C134.237 171.592 134.294 171.75 134.261 171.983C134.228 172.216 134.16 172.446 133.924 172.695C133.467 171.39 133.012 170.986 132.892 170.867C132.559 170.537 132.149 170.251 131.673 170.118C131.079 169.953 130.393 170.033 129.852 170.308C129.276 170.601 128.925 171.034 128.185 170.911C127.818 170.85 127.477 170.699 127.116 170.612C126.344 170.427 125.482 170.559 124.834 170.984C124.186 171.409 123.771 172.124 123.775 172.852C123.777 173.208 123.873 173.557 123.909 173.911C123.945 174.265 123.913 174.645 123.688 174.935C123.531 175.138 123.291 175.284 123.165 175.504C123.02 175.756 123.051 176.059 123.106 176.339C123.16 176.619 123.235 176.906 123.168 177.183C123.121 177.377 122.927 177.675 122.678 177.689C122.392 177.706 122.234 177.279 122.117 177.071C121.16 175.372 119.196 175.373 118.421 176.252C117.646 177.134 117.707 178.022 118.515 179.548C119.058 180.572 120.255 181.055 121.122 180.699C121.275 180.636 121.415 180.548 121.543 180.432C121.59 181.097 121.429 181.932 120.812 182.567C120.215 183.182 119.546 183.509 119.297 183.477C118.894 182.292 117.787 180.95 116.208 178.184C115.432 176.821 115.41 175.15 115.692 173.564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.81 179.207C119.507 175.7 122.417 172.768 128.271 171.516C133.932 170.306 134.244 171.645 134.244 171.645C134.244 171.645 131.759 163.247 122.106 166.349C112.38 169.476 114.804 176.817 116.81 179.207Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37 173.842C123.236 172.076 124.663 170.013 126.279 169.026C127.894 168.04 129.162 167.617 131.664 167.344C133.379 167.156 136.267 167.067 137.066 167.945C137.866 168.823 135.019 171.224 134.272 171.835C132.949 170.258 125.406 172.201 122.37 173.842Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.37 173.842C123.236 172.076 124.663 170.013 126.279 169.026C127.894 168.04 129.162 167.617 131.664 167.344C133.379 167.156 136.267 167.067 137.066 167.945C137.866 168.823 135.019 171.224 134.272 171.835C132.949 170.258 125.406 172.201 122.37 173.842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.191 187.12C112.748 188.266 110.586 192.326 110.442 195.738C110.329 198.39 110.231 201.287 110.282 207.46C110.296 209.026 110.371 211.361 110.264 214.426C110.182 216.77 110.059 220.891 110.059 220.891C110.059 220.891 112.588 225.351 121.394 225.988C134.197 226.915 137.045 221.633 137.045 221.633C137.045 221.633 136.365 221.234 137.47 210.616C138.356 202.102 138.348 194.706 136.732 192.163C136.04 191.321 135.893 187.128 134.092 187.665C131.097 188.557 127.434 188.374 125.242 187.987C117.972 186.702 116.579 186.407 115.191 187.12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.972 164.634C144.422 164.468 143.891 164.249 143.379 163.979C141.856 163.175 135.405 159.79 133.844 158.961C121.978 152.68 125.855 125.946 129.12 115.036L138.789 120.12C136.697 126.693 135.653 133.768 135.653 141.355C135.653 151.916 137.606 158.974 141.521 162.538C142.57 163.494 143.719 164.192 144.972 164.634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.627 110.86C155.698 110.772 155.77 110.689 155.847 110.602C154.712 111.847 153.693 113.271 152.793 114.873C150.677 118.643 149.467 123.111 149.15 128.269C151.85 123.561 155.406 120.045 159.814 117.721C162.787 116.153 165.505 115.59 167.98 116.027C168.75 116.162 169.473 116.394 170.148 116.721C168.277 115.752 162.289 112.598 160.628 111.729C159.154 110.964 157.455 110.636 155.627 110.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.666 89.3185C172.953 88.6412 170.886 88.5282 168.454 88.9865C166.027 89.4449 163.462 90.3841 160.763 91.8076C155.766 94.4371 151.377 98.1715 147.6 103.011C143.819 107.846 140.88 113.55 138.789 120.119L129.12 115.034C133.193 101.062 147.801 81.0545 164.998 84.2344L174.666 89.3185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.344 156.089C159.315 155.983 159.282 155.877 159.247 155.772C159.196 155.623 159.135 155.471 159.012 155.363C158.807 155.184 158.468 155.178 158.222 155.307C157.977 155.435 157.818 155.673 157.741 155.922C157.663 156.17 157.657 156.432 157.651 156.69C157.541 156.435 157.446 156.24 157.129 156.257C156.931 156.266 156.783 156.316 156.657 156.448C156.415 156.704 156.281 157.13 156.271 157.464C156.259 157.847 156.35 158.225 156.427 158.602C156.77 160.278 156.843 162.048 156.214 163.653C156.191 163.713 156.151 163.782 156.081 163.781C156.031 163.781 155.992 163.739 155.964 163.701C155.599 163.223 155.497 162.637 155.386 162.075C155.285 161.565 155.214 160.907 154.77 160.541C154.65 160.442 154.508 160.357 154.347 160.336C154.187 160.317 154.007 160.376 153.932 160.506C153.897 160.566 153.887 160.635 153.877 160.702C153.718 161.784 153.561 162.887 153.706 163.977C153.774 164.492 153.995 164.947 154.115 165.439C154.231 165.917 154.534 166.417 154.647 166.895C155.018 168.485 154.806 169.054 153.954 171.491C152.695 175.095 150.624 180.585 150.624 180.585C150.624 180.585 144.435 183.941 141.801 185.155C139.167 186.369 136.667 186.773 134.797 187.771C131.387 191.715 133.762 200.886 137.784 199.96C139.035 197.387 140.704 196.092 147.239 192.485C151.022 190.396 153.921 188.406 156.015 187.091C158.584 185.477 158.801 184.549 159.338 180.051C159.818 176.018 160.466 172.295 160.667 170.646C160.828 169.328 161.209 167.898 161.784 166.678C162.409 165.353 162.714 164.179 163.018 162.761C163.293 161.476 163.217 160.396 162.97 159.167C162.925 158.945 162.689 158.032 162.331 158.03C162.278 158.03 162.228 158.054 162.184 158.082C161.894 158.263 161.869 158.493 161.863 158.815C161.856 159.201 161.905 159.433 161.913 159.754C161.932 160.442 161.848 161.136 161.611 161.791C161.598 161.827 161.572 161.871 161.53 161.867C161.494 161.863 161.476 161.826 161.468 161.794C161.426 161.64 161.422 161.479 161.417 161.32C161.382 160.287 161.288 159.25 161.015 158.247C160.951 158.008 160.874 157.769 160.738 157.557C160.602 157.345 160.4 157.161 160.145 157.08C159.97 157.025 159.741 157.028 159.621 156.888C159.497 156.745 159.458 156.579 159.421 156.403C159.399 156.298 159.374 156.193 159.344 156.089Z",
    fill: "#FFBDA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.867 157.089C157.923 157.641 158.047 158.18 158.129 158.728C158.206 159.242 158.27 159.759 158.301 160.279C158.331 160.767 158.333 161.259 158.295 161.746C158.256 162.265 158.173 162.777 158.117 163.294C158.115 163.318 158.164 163.32 158.17 163.3C158.465 162.308 158.567 161.186 158.505 160.146C158.474 159.631 158.395 159.121 158.288 158.618C158.178 158.101 158.066 157.585 157.893 157.089C157.89 157.077 157.866 157.074 157.867 157.089Z",
    fill: "#F0997A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.533 156.817C159.589 157.368 159.713 157.907 159.796 158.456C159.872 158.97 159.937 159.487 159.969 160.007C159.999 160.495 160 160.986 159.963 161.473C159.924 161.993 159.84 162.505 159.785 163.021C159.783 163.045 159.832 163.047 159.838 163.027C160.133 162.036 160.236 160.913 160.173 159.874C160.143 159.358 160.063 158.848 159.956 158.346C159.846 157.828 159.734 157.313 159.559 156.817C159.556 156.805 159.532 156.802 159.533 156.817Z",
    fill: "#F0997A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.176 187.898C134.063 187.705 134.93 187.379 135.756 187.1C136.581 186.821 141.716 185.176 144.31 183.766C147.525 184.2 149.454 189.313 147.845 192.558C145.773 193.721 142.222 195.517 140.57 196.851C138.769 198.305 138.133 200.091 138.062 201.198C137.991 202.306 135.32 200.999 133.855 197.946C132.39 194.894 131.897 189.649 133.176 187.898Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.344 267.788C111.046 267.011 111.196 264.353 111.445 259.922L120.311 261.686C120.311 261.686 117.177 270.794 116.812 271.673C116.213 273.119 110.344 267.788 110.344 267.788Z",
    fill: "#FFBDA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.348 268.804C109.538 268.387 109.802 268.003 110.064 267.621C110.374 267.17 110.508 266.427 111.026 266.129C111.198 266.03 111.397 265.979 111.595 265.937C112.023 265.845 112.465 265.804 112.905 265.833C113.293 265.86 113.79 265.919 114.124 266.114C114.43 266.293 114.766 266.431 115.069 266.62C115.381 266.815 115.671 267.039 115.927 267.292C116.161 267.525 116.365 267.782 116.528 268.061C116.658 268.284 116.761 268.519 116.836 268.762C116.956 269.152 117 269.558 117.021 269.961C117.03 270.137 117.034 270.511 117.002 270.803C117.211 270.249 117.683 269.259 117.683 269.259C118.056 269.65 117.635 270.452 117.554 270.896C117.445 271.499 117.371 272.106 117.333 272.716C117.27 273.724 117.199 274.755 117.447 275.749C117.525 276.06 117.614 276.317 117.698 276.52C118.191 277.718 120.119 277.672 120.906 278.666C121.147 278.971 121.272 279.34 121.35 279.708C121.415 280.016 121.448 280.335 121.371 280.64C121.243 281.15 120.813 281.563 120.317 281.826C118.881 282.585 116.92 283.02 115.344 282.346C115.246 282.299 115.159 282.259 115.073 282.207C113.598 281.349 109.969 279.144 109.967 278.876C109.967 278.861 109.978 278.849 109.979 278.834C110.022 277.98 110.048 277.127 110.075 276.273C110.135 274.328 109.25 272.424 109.092 270.488C109.047 269.919 109.106 269.332 109.348 268.804Z",
    fill: "#E2982C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.298 270.322C109.275 270.324 109.252 270.327 109.229 270.331C108.955 270.367 108.669 270.477 108.538 270.699C108.482 270.795 108.458 270.903 108.444 271.012C108.366 271.598 108.539 272.187 108.725 272.752C109.162 274.067 109.764 275.479 109.532 276.876C109.39 277.726 108.919 278.979 109.683 279.702C110.286 280.271 114.784 282.968 114.784 282.968C114.784 282.968 113.919 280.653 113.97 277.379C114.003 275.276 114.365 272.55 112.191 271.195C111.801 270.953 111.367 270.775 110.929 270.618C110.407 270.43 109.852 270.267 109.298 270.322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.52 280.503C121.513 280.382 121.496 280.198 121.409 280.083C121.282 280.607 120.853 281.066 120.37 281.376C120.109 281.543 119.839 281.695 119.558 281.833C119.284 281.967 119.006 282.027 118.706 282.1C118.339 282.19 117.964 282.257 117.586 282.286C116.845 282.342 116.058 282.245 115.461 281.811C114.51 281.119 114.439 279.814 114.471 278.798C114.519 277.269 114.569 275.733 114.45 274.206C114.35 272.914 114.273 271.697 113.107 270.803C112.493 270.332 111.742 270.034 110.977 269.815C110.594 269.705 110.2 269.613 109.799 269.603C109.497 269.596 109.166 269.649 108.972 269.86C108.86 269.983 108.805 270.144 108.73 270.286C108.69 270.363 108.619 270.616 108.573 270.654C108.787 270.476 109.113 270.482 109.402 270.511C110.316 270.602 111.239 270.819 111.988 271.308C112.925 271.919 113.266 272.839 113.369 273.842C113.49 275.017 113.467 276.202 113.431 277.379C113.355 279.883 113.308 282.786 115.389 283.186C115.753 283.256 116.123 283.294 116.494 283.299C117.393 283.31 118.279 283.121 119.11 282.815C119.886 282.529 120.579 282.24 121.103 281.614C121.226 281.466 121.336 281.309 121.41 281.137C121.496 280.935 121.533 280.718 121.52 280.503Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.585 276.159C117.585 276.159 117.855 276.347 117.87 276.636C117.885 276.926 117.723 277.582 117.034 277.914C116.742 278.055 116.502 277.983 116.988 277.478C117.475 276.972 117.585 276.159 117.585 276.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.283 274.626C117.283 274.626 117.452 274.788 117.451 275.017C117.451 275.246 116.955 276.167 116.449 276.353C115.944 276.539 116.238 276.035 116.48 275.804C116.722 275.575 117.283 274.626 117.283 274.626Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.462 272.821C117.462 272.821 117.573 273.065 117.461 273.369C117.389 273.562 116.506 274.046 116.192 274.008C115.876 273.97 115.768 273.795 116.212 273.635C116.562 273.51 117.327 273.083 117.462 272.821Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.707 270.416C123.501 271.162 123.262 271.72 123.998 272.633C124.734 273.547 126.36 274.067 127.99 274.056C129.419 274.046 130.334 273.517 131.176 272.948C132.134 272.303 132.809 271.735 133.168 271.468C133.527 271.201 134.941 270.878 136.277 270.663C137.684 270.435 140.394 269.96 141.812 268.163C143.23 266.365 143.034 264.764 143.034 264.764L123.707 270.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.191 263.415C131.302 264.253 126.86 262.642 125.185 264.413C124.387 265.058 123.613 268.932 123.552 270.957C124.493 273.062 127.659 273.663 129.789 272.877C130.897 272.351 131.646 271.59 132.738 271.013C133.601 270.557 134.513 270.368 135.526 270.189C136.455 270.025 138.06 269.634 138.856 269.352C141.702 268.235 143.16 266.078 143.038 264.298C142.931 262.736 141.833 261.612 139.027 261.936C137.776 262.08 136.178 262.839 134.191 263.415Z",
    fill: "#E2982C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.325 262.71C136.529 262.405 136.81 262.303 137.18 262.414C137.238 262.441 137.295 262.463 137.352 262.494C138.361 263.034 138.934 263.968 138.943 264.225C138.951 264.482 138.695 264.787 138.468 264.496C138.241 264.206 137.661 263.416 136.844 262.939C136.669 262.837 136.494 262.767 136.325 262.71Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.515 265.258C136.288 264.968 135.678 263.937 134.86 263.461C134.756 263.4 134.652 263.349 134.551 263.304C134.672 262.964 134.999 262.981 135.349 263.047C136.32 263.602 136.981 264.735 136.989 264.986C136.999 265.244 136.743 265.548 136.515 265.258Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.614 263.712C132.88 263.458 133.171 263.37 133.509 263.574C134.404 264.268 134.898 265.495 134.87 265.751C134.84 266.015 134.532 266.294 134.343 265.969C134.155 265.643 133.688 264.511 132.923 263.921C132.82 263.842 132.717 263.774 132.614 263.712Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.88 259.158C126.888 259.241 125.35 265.26 125.35 265.26C125.35 265.26 126.256 266.699 128.83 266.777C131.406 266.855 132.684 266.145 133.105 265.485C133.105 265.485 134.683 262.381 135.068 261.085L126.88 259.158Z",
    fill: "#FFBDA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.06 232.972C111.217 238.532 112.421 245.887 112.421 245.887C112.421 245.887 111.731 249.09 111.52 253.077C111.174 259.595 111.024 264.277 111.024 264.277C111.024 264.277 112.85 263.506 115.329 264.615C117.808 265.724 118.65 267.347 118.65 267.347C118.65 267.347 122.621 257.93 124.405 248.711C125.339 243.881 125.675 240.515 126.109 236.702C129.185 241.249 131.809 245.185 131.809 245.185C131.809 245.185 129.928 246.899 128.432 252.32C126.771 258.336 125.976 262.217 125.976 262.217C125.976 262.217 126.174 262.92 129.298 264.25C131.824 265.325 134.101 264.606 134.101 264.606C134.101 264.606 141.456 253.248 143.1 250.274C146.182 244.7 145.734 243.661 144.007 237.609C141.958 230.428 139.745 228.094 137.384 221.178C136.808 218.418 137.467 212.951 137.467 212.951C127.997 212.351 127.183 193.405 131.001 188.227L128.187 188.289C126.438 189.537 122.195 194.874 120.441 197.452C119.113 193.376 118.762 189.843 119.29 186.875L116.478 186.607C112.851 191.436 111.006 199.386 110.11 209.208C110.11 209.208 109.651 214.159 109.402 217.776C109.154 221.392 108.131 223.7 110.06 232.972Z",
    fill: "#E2982C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.709 232.053C122.029 233.242 123.432 233.789 124.726 234.345C124.726 234.347 125.988 236.218 125.988 236.218L126.109 236.702C125.745 239.906 125.448 242.797 124.809 246.504C124.825 243.87 124.856 238.53 124.856 238.53C124.856 238.53 124.72 236.757 124.334 236.286C123.509 235.28 122.173 234.818 119.771 232.555C118.262 231.134 117.377 229.585 117.697 226.222C117.877 228.937 118.965 230.483 120.709 232.053Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.042 224.351C114.012 224.079 113.009 223.726 112.031 223.326C111.543 223.127 111.061 222.916 110.582 222.697C110.353 222.593 109.585 222.046 109.343 222.277C109.277 222.34 109.267 222.435 109.262 222.521C109.181 223.786 109.289 225.054 109.395 226.317C109.457 227.047 109.532 227.73 109.645 228.54C109.701 228.944 109.789 229.324 109.932 229.71C110.15 230.299 110.453 230.718 110.845 231.201C111.289 231.748 111.756 232.277 112.227 232.805C112.381 232.977 112.542 233.186 112.799 233.231C113.092 233.283 113.378 233.076 113.597 232.93C114.134 232.569 114.562 232.091 114.935 231.592C115.288 231.121 115.781 230.598 115.703 229.997C115.469 228.195 115.277 226.408 115.275 224.592C115.274 224.473 115.156 224.382 115.042 224.351ZM115.053 228.542C115.098 228.893 115.149 229.244 115.204 229.595C115.227 229.741 115.269 229.894 115.272 230.041C115.277 230.266 115.162 230.428 115.035 230.612C114.709 231.088 114.359 231.559 113.951 231.981C113.735 232.203 113.499 232.41 113.237 232.588C113.153 232.644 113.016 232.765 112.914 232.784C112.686 232.826 112.537 232.56 112.417 232.425C111.588 231.495 110.491 230.575 110.137 229.389C110.028 229.024 109.98 228.646 109.932 228.271C109.813 227.329 109.717 226.39 109.652 225.445C109.587 224.495 109.599 223.534 109.574 222.582C109.935 222.718 110.299 222.885 110.637 223.062C111.08 223.294 111.535 223.506 111.999 223.701C112.91 224.084 113.855 224.399 114.815 224.663C114.819 225.959 114.889 227.254 115.053 228.542Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.352 221.02C137.315 220.837 137.3 220.647 137.28 220.447C136.639 220.641 135.958 220.832 135.308 220.99C135.226 220.776 135.152 220.559 135.092 220.339C135.045 220.163 135.004 219.984 134.974 219.805C134.957 219.703 134.942 219.598 134.917 219.496C135.617 219.344 136.472 219.195 137.162 219.005C137.157 218.779 137.151 218.557 137.149 218.344C130.675 220.186 125.348 219.68 118.755 218.279C118.802 215.932 118.887 213.584 119.036 211.24C119.115 210.003 119.21 208.766 119.323 207.531C119.426 206.398 119.586 205.255 119.602 204.117C120.162 204.2 120.722 204.277 121.285 204.341C121.796 204.399 122.672 204.657 122.733 203.962C122.791 203.291 122.722 202.613 122.893 201.952C123.016 201.477 123.545 200.771 122.761 200.53C122.393 200.417 121.951 200.415 121.567 200.359C121.121 200.295 120.675 200.222 120.232 200.141C120.195 200.134 120.158 200.125 120.122 200.118C120.147 199.994 120.148 199.858 120.163 199.737C120.193 199.508 120.225 199.28 120.262 199.051C120.329 198.625 120.408 198.201 120.498 197.779C120.543 197.57 120.597 197.364 120.653 197.158C120.582 197.258 120.505 197.36 120.442 197.454C120.398 197.32 120.365 197.193 120.323 197.06C120.277 197.278 120.234 197.496 120.188 197.714C120.092 198.166 120.008 198.622 119.938 199.079C119.905 199.292 119.875 199.506 119.848 199.72C119.833 199.842 119.815 199.95 119.817 200.057C119.39 199.975 118.965 199.89 118.54 199.798C118.087 199.699 117.654 199.473 117.178 199.583C116.809 199.668 116.843 199.831 116.788 200.146C116.682 200.744 116.582 201.343 116.478 201.942C116.417 202.298 116.318 202.666 116.294 203.025C116.276 203.284 116.415 203.473 116.673 203.575C116.977 203.695 117.343 203.727 117.666 203.79C118.082 203.87 118.498 203.945 118.915 204.014C119.047 204.036 119.18 204.054 119.312 204.075C119.061 205.219 118.981 206.409 118.875 207.569C118.763 208.782 118.668 209.996 118.589 211.211C118.438 213.535 118.356 215.862 118.342 218.191C117.048 217.904 115.768 217.572 114.51 217.185C113.365 216.832 112.232 216.433 111.174 215.895C110.623 215.615 110.108 215.29 109.615 214.937C109.6 215.127 109.585 215.317 109.57 215.508C110.668 216.309 112.047 216.863 113.283 217.303C114.608 217.775 115.972 218.164 117.349 218.498C117.251 218.766 117.181 219.039 117.147 219.326C117.114 219.61 117.096 219.901 117.098 220.188C116.133 219.954 115.176 219.695 114.232 219.404C113.086 219.052 111.953 218.653 110.895 218.114C110.383 217.853 109.901 217.555 109.439 217.231C109.426 217.415 109.413 217.598 109.401 217.777C109.4 217.788 109.399 217.798 109.398 217.809C110.478 218.567 111.81 219.098 113.005 219.522C115.125 220.276 117.334 220.838 119.559 221.26C124.052 222.109 126.87 222.871 131.42 222.283C132.903 222.091 134.375 221.806 135.816 221.442C135.931 221.413 137.009 221.147 137.286 221.051C137.33 221.036 137.354 221.025 137.352 221.02ZM118.735 203.579C118.442 203.529 118.151 203.477 117.86 203.423C117.695 203.392 117.531 203.36 117.366 203.327C117.232 203.3 116.996 203.3 116.886 203.229C116.713 203.116 116.904 202.522 116.935 202.333C116.986 202.024 117.038 201.714 117.088 201.404C117.139 201.095 117.191 200.785 117.242 200.475C117.315 200.032 117.309 199.907 117.852 199.979C118.233 200.029 118.59 200.174 118.962 200.261C119.655 200.423 120.357 200.556 121.061 200.675C121.348 200.724 121.636 200.769 121.925 200.811C122.068 200.832 122.212 200.852 122.357 200.872C122.568 200.899 122.716 200.921 122.618 201.155C122.436 201.585 122.297 201.988 122.254 202.452C122.231 202.702 122.234 202.951 122.244 203.202C122.252 203.407 122.335 203.725 122.267 203.922C122.185 204.155 121.655 204.011 121.461 203.987C121.142 203.947 120.825 203.905 120.507 203.86C119.915 203.776 119.325 203.679 118.735 203.579ZM119.168 219.065C119.139 219.151 119.118 219.241 119.095 219.329C119.048 219.514 119.017 219.701 118.994 219.889C118.971 220.076 118.955 220.263 118.948 220.45C118.947 220.5 118.947 220.55 118.946 220.6C118.52 220.513 118.095 220.421 117.672 220.323C117.672 220.321 117.672 220.32 117.672 220.318C117.669 220.231 117.667 220.143 117.667 220.056C117.667 219.869 117.673 219.682 117.686 219.496C117.699 219.311 117.721 219.127 117.74 218.943C117.752 218.827 117.748 218.709 117.75 218.593C117.996 218.651 118.242 218.707 118.489 218.761C118.547 218.792 118.608 218.806 118.658 218.795C118.846 218.835 119.035 218.874 119.224 218.912C119.2 218.968 119.181 219.025 119.168 219.065ZM119.484 220.702C119.487 220.623 119.485 220.547 119.488 220.495C119.496 220.308 119.513 220.121 119.538 219.936C119.562 219.753 119.592 219.571 119.624 219.39C119.645 219.269 119.679 219.132 119.672 219.005C119.727 219.016 119.782 219.029 119.838 219.039C124.331 219.889 127.149 220.65 131.699 220.063C132.219 219.995 132.735 219.91 133.251 219.823C133.262 219.894 133.273 219.962 133.28 220.019C133.305 220.224 133.337 220.428 133.375 220.631C133.412 220.827 133.452 221.021 133.497 221.215C133.509 221.267 133.523 221.319 133.535 221.372C128.312 222.367 124.725 221.699 119.484 220.702ZM134.061 221.269C134.059 221.262 134.056 221.253 134.054 221.246C134.032 221.166 134.011 221.086 133.99 221.006C133.945 220.831 133.904 220.657 133.866 220.482C133.829 220.308 133.791 220.134 133.757 219.96C133.743 219.889 133.732 219.817 133.717 219.746C133.982 219.698 134.243 219.636 134.507 219.582C134.512 219.64 134.519 219.697 134.525 219.75C134.549 219.946 134.584 220.141 134.627 220.334C134.685 220.591 134.769 220.843 134.864 221.09C134.596 221.151 134.329 221.214 134.061 221.269Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.553 231.537C133.733 231.081 133.619 230.659 133.5 230.204C133.221 229.146 132.952 228.085 132.678 227.026C132.577 226.636 132.551 226.061 132.274 225.735C132.01 225.424 131.586 225.542 131.226 225.603C129.665 225.864 128.079 226.001 126.491 226.004C125.698 226.005 124.904 225.973 124.113 225.906C123.85 225.883 123.485 225.725 123.225 225.819C122.972 225.91 123.017 226.234 123.043 226.428C123.085 226.731 123.108 227.032 123.15 227.335C123.23 227.902 123.396 228.457 123.615 228.992C124.058 230.071 124.714 231.065 125.403 232.027C125.67 232.399 125.92 232.81 126.246 233.143C126.573 233.476 126.987 233.598 127.448 233.715C128.639 234.016 129.848 234.311 131.064 234.512C131.48 234.581 131.733 234.494 131.96 234.163C132.283 233.692 132.573 233.199 132.879 232.718C133.12 232.338 133.389 231.952 133.553 231.537ZM131.52 233.941C131.251 234.319 130.394 234.008 129.989 233.924C129.46 233.815 128.934 233.699 128.41 233.577C127.934 233.466 127.41 233.386 126.958 233.209C126.429 233.002 126.136 232.412 125.83 231.992C124.589 230.282 123.461 228.44 123.414 226.338C123.413 226.312 123.403 226.287 123.388 226.263C125.303 226.475 127.231 226.504 129.151 226.318C129.651 226.269 130.151 226.209 130.647 226.13C130.91 226.089 131.173 226.04 131.434 225.99C131.648 225.949 131.967 225.818 132.102 226.021C132.203 226.175 132.211 226.443 132.256 226.621C132.316 226.852 132.375 227.082 132.433 227.313C132.557 227.797 132.682 228.282 132.806 228.766C132.918 229.204 133.031 229.643 133.143 230.081C133.282 230.631 133.377 231.089 133.055 231.607C132.569 232.389 132.057 233.186 131.52 233.941Z",
    fill: "#8D5E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.216 189.271C164.292 189.036 164.601 188.824 165.128 188.69C166.179 188.422 167.698 188.57 168.518 189.02C168.928 189.245 169.086 189.503 169.01 189.738C168.964 189.881 133.618 299.457 133.572 299.599C133.496 299.834 133.187 300.046 132.661 300.18C131.609 300.448 130.091 300.3 129.271 299.85C128.861 299.624 128.702 299.367 128.778 299.132C128.824 298.989 164.17 189.413 164.216 189.271Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.518 189.02C168.928 189.246 169.087 189.503 169.011 189.738C168.934 189.973 168.625 190.185 168.099 190.319C167.047 190.587 165.53 190.439 164.709 189.989C164.299 189.764 164.141 189.506 164.217 189.271C164.293 189.036 164.602 188.824 165.128 188.69C166.18 188.423 167.697 188.571 168.518 189.02Z",
    fill: "#B4751A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.518 189.02C168.928 189.246 169.087 189.503 169.011 189.738C168.934 189.973 168.625 190.185 168.099 190.319C167.047 190.587 165.53 190.439 164.709 189.989C164.299 189.764 164.141 189.506 164.217 189.271C164.293 189.036 164.602 188.824 165.128 188.69C166.18 188.423 167.697 188.571 168.518 189.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2247 159.69L31.3408 163.327L34.0754 168.936C34.1347 169.059 34.2285 169.147 34.337 169.204C34.6639 169.373 37.7439 170.992 37.8508 171.048C38.1778 171.221 38.6493 171.099 38.7747 170.712L41.7439 161.537L38.2247 159.69Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2247 159.69L31.3408 163.327L34.0754 168.936C34.1347 169.059 34.2285 169.147 34.337 169.204C34.6639 169.373 37.7439 170.992 37.8508 171.048C38.1778 171.221 38.6493 171.099 38.7747 170.712L41.7439 161.537L38.2247 159.69Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M37.5921 170.782L35.2344 165.945L41.359 162.719L38.7729 170.711C38.6067 171.225 37.8305 171.271 37.5921 170.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46854 173.963L6.46777 150.895C6.46777 150.34 6.89393 149.666 7.42008 149.389L41.5341 131.452C42.0602 131.175 42.911 131.179 43.4341 131.461L47.2756 133.522C47.7987 133.805 48.2226 134.483 48.2226 135.037L48.2241 158.105C48.2241 158.66 47.7972 159.334 47.271 159.611L13.157 177.547C12.6309 177.824 11.7801 177.821 11.257 177.539L7.41547 175.477C6.89239 175.196 6.46854 174.517 6.46854 173.963Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.46854 173.963L6.46777 150.895C6.46777 150.34 6.89393 149.666 7.42008 149.389L41.5341 131.452C42.0602 131.175 42.911 131.179 43.4341 131.461L47.2756 133.522C47.7987 133.805 48.2226 134.483 48.2226 135.037L48.2241 158.105C48.2241 158.66 47.7972 159.334 47.271 159.611L13.157 177.547C12.6309 177.824 11.7801 177.821 11.257 177.539L7.41547 175.477C6.89239 175.196 6.46854 174.517 6.46854 173.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0017 177.616C12.5486 177.777 12.2047 177.545 12.2032 177.045L12.2047 153.979C12.2063 153.7 12.3117 153.394 12.4855 153.122L6.72702 150.069C6.56548 150.335 6.46625 150.628 6.46779 150.896V173.966C6.46702 174.518 6.8901 175.195 7.41549 175.479L11.2555 177.54C11.7317 177.794 12.477 177.824 13.0017 177.616Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.0017 177.616C12.5486 177.777 12.2047 177.545 12.2032 177.045L12.2047 153.979C12.2063 153.7 12.3117 153.394 12.4855 153.122L6.72702 150.069C6.56548 150.335 6.46625 150.628 6.46779 150.896V173.966C6.46702 174.518 6.8901 175.195 7.41549 175.479L11.2555 177.54C11.7317 177.794 12.477 177.824 13.0017 177.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2243 139.062L48.2235 135.037C48.2235 134.483 47.7966 134.258 47.2704 134.535L13.1564 152.472C12.6303 152.749 12.2041 153.424 12.2041 153.978L12.2056 177.046C12.2056 177.6 12.6318 177.825 13.1587 177.548L47.2727 159.612C47.7989 159.334 48.2258 158.66 48.2258 158.106L48.225 150.031L48.2243 139.062Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M48.2241 150.031V139.063L48.2233 135.038C48.2233 134.483 47.7964 134.259 47.2702 134.536L13.1562 152.473C12.6301 152.75 12.2031 153.425 12.2031 153.979L12.2047 177.047C12.2047 177.601 12.6308 177.826 13.1577 177.548L47.2717 159.612C47.7979 159.335 48.2248 158.66 48.2248 158.107L48.2241 150.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1057 158.741C18.9134 159.37 17.9473 161.054 17.9473 162.505C17.9473 163.956 18.9134 164.622 20.1057 163.994C21.2981 163.366 22.2642 161.681 22.2642 160.23C22.265 158.78 21.2981 158.113 20.1057 158.741ZM30.215 153.415C29.0227 154.043 28.0565 155.728 28.0565 157.178C28.0565 158.628 29.0227 159.295 30.215 158.667C31.4073 158.039 32.3735 156.354 32.3735 154.904C32.3735 153.454 31.4073 152.788 30.215 153.415ZM40.3243 148.089C39.132 148.718 38.1658 150.402 38.1658 151.853C38.1658 153.304 39.132 153.97 40.3243 153.342C41.5166 152.714 42.4828 151.029 42.4828 149.578C42.4828 148.128 41.5166 147.461 40.3243 148.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8448 87.2441L50.9609 90.8816L53.6956 96.4909C53.7548 96.613 53.8486 96.7015 53.9571 96.7583C54.284 96.9275 57.364 98.5462 57.471 98.6023C57.7979 98.775 58.2694 98.6536 58.3948 98.2668L61.3641 89.091L57.8448 87.2441Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2132 98.3369L54.8555 93.4998L60.9801 90.2729L58.3939 98.2653C58.2278 98.7791 57.4516 98.8255 57.2132 98.3369Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0906 101.517L26.0898 78.4493C26.0898 77.8948 26.516 77.2209 27.0422 76.9437L61.1562 59.0069C61.6823 58.7296 62.5331 58.7338 63.0562 59.0153L66.8977 61.0769C67.4208 61.3591 67.8454 62.0372 67.8446 62.5917L67.8462 85.6597C67.8462 86.2143 67.4193 86.8881 66.8931 87.1654L32.7791 105.102C32.2529 105.379 31.4022 105.376 30.8791 105.094L27.0375 103.032C26.5145 102.75 26.0906 102.072 26.0906 101.517Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6237 105.171C32.1707 105.331 31.826 105.099 31.8253 104.6L31.8268 81.5336C31.8283 81.2549 31.9337 80.9482 32.1076 80.6765L26.3491 77.623C26.1868 77.8891 26.0883 78.1825 26.0899 78.4506V101.52C26.0891 102.073 26.5122 102.749 27.0376 103.033L30.8776 105.094C31.3537 105.348 32.0991 105.377 32.6237 105.171Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8456 66.6166L67.8448 62.5916C67.8448 62.0371 67.4179 61.8125 66.8925 62.0897L32.7785 80.0265C32.2523 80.3038 31.8262 80.9784 31.8262 81.5322L31.8277 104.6C31.8277 105.155 32.2539 105.379 32.7808 105.102L66.8948 87.1653C67.4209 86.8881 67.8479 86.2135 67.8479 85.6597L67.8471 77.5852L67.8456 66.6166Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7259 86.2957C38.5335 86.924 37.5674 88.6086 37.5674 90.0595C37.5674 91.5098 38.5335 92.1766 39.7259 91.5484C40.9182 90.9201 41.8843 89.2355 41.8843 87.7852C41.8843 86.335 40.9182 85.6675 39.7259 86.2957ZM49.8351 80.9693C48.6428 81.5976 47.6767 83.2823 47.6767 84.7325C47.6767 86.1827 48.6428 86.8495 49.8351 86.2213C51.0274 85.5931 51.9936 83.9084 51.9936 82.4575C51.9936 81.0066 51.0274 80.3418 49.8351 80.9693ZM59.9444 75.6437C58.7521 76.2719 57.7859 77.9566 57.7859 79.4068C57.7859 80.857 58.7521 81.5239 59.9444 80.8956C61.1367 80.2674 62.1029 78.5827 62.1029 77.1318C62.1029 75.6823 61.1359 75.0154 59.9444 75.6437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.622 159.69L318.506 163.327L315.771 168.936C315.711 169.059 315.618 169.147 315.509 169.204C315.183 169.373 312.103 170.992 311.996 171.048C311.669 171.221 311.197 171.099 311.072 170.712L308.103 161.537L311.622 159.69Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.622 159.69L318.506 163.327L315.771 168.936C315.711 169.059 315.618 169.147 315.509 169.204C315.183 169.373 312.103 170.992 311.996 171.048C311.669 171.221 311.197 171.099 311.072 170.712L308.103 161.537L311.622 159.69Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M312.253 170.782L314.611 165.945L308.486 162.719L311.072 170.711C311.239 171.225 312.015 171.271 312.253 170.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.377 173.963V150.895C343.377 150.34 342.951 149.666 342.425 149.389L308.311 131.452C307.785 131.175 306.934 131.179 306.411 131.461L302.57 133.522C302.046 133.805 301.622 134.483 301.623 135.037L301.621 158.105C301.621 158.66 302.048 159.334 302.574 159.611L336.688 177.547C337.214 177.824 338.065 177.821 338.588 177.539L342.43 175.477C342.953 175.196 343.377 174.517 343.377 173.963Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M343.377 173.963V150.895C343.377 150.34 342.951 149.666 342.425 149.389L308.311 131.452C307.785 131.175 306.934 131.179 306.411 131.461L302.57 133.522C302.046 133.805 301.622 134.483 301.623 135.037L301.621 158.105C301.621 158.66 302.048 159.334 302.574 159.611L336.688 177.547C337.214 177.824 338.065 177.821 338.588 177.539L342.43 175.477C342.953 175.196 343.377 174.517 343.377 173.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.844 177.616C337.297 177.777 337.641 177.545 337.642 177.045L337.641 153.979C337.639 153.7 337.534 153.394 337.36 153.122L343.118 150.069C343.28 150.335 343.379 150.628 343.378 150.896V173.966C343.378 174.518 342.955 175.195 342.43 175.479L338.59 177.54C338.114 177.794 337.368 177.824 336.844 177.616Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M336.844 177.616C337.297 177.777 337.641 177.545 337.642 177.045L337.641 153.979C337.639 153.7 337.534 153.394 337.36 153.122L343.118 150.069C343.28 150.335 343.379 150.628 343.378 150.896V173.966C343.378 174.518 342.955 175.195 342.43 175.479L338.59 177.54C338.114 177.794 337.368 177.824 336.844 177.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.622 139.062V135.037C301.622 134.483 302.049 134.258 302.575 134.535L336.689 152.472C337.215 152.749 337.641 153.424 337.641 153.978L337.639 177.046C337.639 177.6 337.213 177.825 336.687 177.548L302.573 159.612C302.047 159.334 301.62 158.66 301.62 158.106L301.621 150.031L301.622 139.062Z",
    fill: "#9474CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M301.621 150.031V139.063L301.622 135.038C301.622 134.483 302.049 134.259 302.575 134.536L336.689 152.473C337.215 152.75 337.641 153.425 337.641 153.979L337.639 177.047C337.639 177.601 337.213 177.826 336.687 177.548L302.573 159.612C302.047 159.335 301.62 158.66 301.62 158.107L301.621 150.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.581 160.23C327.581 161.681 328.547 163.366 329.739 163.994C330.932 164.622 331.898 163.956 331.898 162.505C331.898 161.055 330.932 159.37 329.739 158.741C328.547 158.113 327.581 158.78 327.581 160.23ZM317.472 154.905C317.472 156.355 318.438 158.04 319.63 158.668C320.822 159.296 321.789 158.629 321.789 157.179C321.789 155.729 320.822 154.043 319.63 153.416C318.438 152.788 317.472 153.454 317.472 154.905ZM307.362 149.578C307.362 151.029 308.328 152.714 309.521 153.342C310.713 153.97 311.679 153.304 311.679 151.853C311.679 150.403 310.713 148.718 309.521 148.089C308.329 147.461 307.362 148.128 307.362 149.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.002 87.2441L298.886 90.8816L296.151 96.4909C296.091 96.613 295.998 96.7015 295.889 96.7583C295.562 96.9275 292.482 98.5462 292.375 98.6023C292.049 98.775 291.577 98.6536 291.452 98.2668L288.482 89.091L292.002 87.2441Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.632 98.3369L294.991 93.4998L288.866 90.2729L291.452 98.2653C291.618 98.7791 292.394 98.8255 292.632 98.3369Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.756 101.517V78.4493C323.756 77.8948 323.33 77.2209 322.804 76.9437L288.69 59.0069C288.164 58.7296 287.313 58.7338 286.79 59.0153L282.948 61.0769C282.425 61.3591 282.001 62.0372 282.002 62.5917L282 85.6597C282 86.2143 282.426 86.8881 282.953 87.1654L317.067 105.102C317.593 105.379 318.444 105.376 318.967 105.094L322.809 103.032C323.331 102.75 323.756 102.072 323.756 101.517Z",
    fill: "#7D67A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.223 105.171C317.676 105.331 318.02 105.099 318.021 104.6L318.02 81.5336C318.018 81.2549 317.913 80.9482 317.739 80.6765L323.497 77.623C323.659 77.8891 323.758 78.1825 323.757 78.4506L323.756 101.52C323.757 102.073 323.333 102.749 322.808 103.033L318.968 105.094C318.493 105.348 317.748 105.377 317.223 105.171Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.001 66.6166V62.5916C282.001 62.0371 282.428 61.8125 282.954 62.0897L317.068 80.0265C317.594 80.3038 318.02 80.9784 318.02 81.5322L318.018 104.6C318.018 105.155 317.592 105.379 317.066 105.102L282.952 87.1653C282.426 86.8881 281.999 86.2135 281.999 85.6597L282 77.5852L282.001 66.6166Z",
    fill: "#8846C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.961 87.7845C307.961 89.2347 308.927 90.9201 310.119 91.5476C311.312 92.1759 312.278 91.509 312.278 90.0588C312.278 88.6086 311.312 86.9232 310.119 86.295C308.927 85.6674 307.961 86.3343 307.961 87.7845ZM297.851 82.4588C297.851 83.909 298.818 85.5944 300.01 86.2227C301.202 86.8509 302.168 86.184 302.168 84.7338C302.168 83.2836 301.202 81.5982 300.01 80.9707C298.818 80.3417 297.851 81.0079 297.851 82.4588ZM287.742 77.1325C287.742 78.5827 288.708 80.2681 289.901 80.8963C291.093 81.5245 292.059 80.8577 292.059 79.4075C292.059 77.9572 291.093 76.2719 289.901 75.6443C288.709 75.0154 287.742 75.6822 287.742 77.1325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1692_12071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 346,
    height: 307,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecommunications);
export default __webpack_public_path__ + "static/media/Telecommunications.c1698484a90cafef07d146b279d2f420.svg";
export { ForwardRef as ReactComponent };